import { AdminInvoicesTab } from "./admin/components/AdminInvoicesTab";
import { AdminOrdersTab, AdminTransactionsTab } from "./admin/components/AdminOrdersTransactionsTab";
import { AdminUsersTab } from "./admin/components/AdminUsersTab";
import { AdminMerchantsTab } from "./admin/components/AdminMerchantsTab";
import { AdminSubscriptionsTab } from "./admin/components/AdminSubscriptionsTab";
import { CommerceManagement } from "./admin/commerce/CommerceManagement";
import { PulseLaunchSubscribers } from "./admin/pulse/PulseLaunchSubscribers";

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useAuth, API } from "@/App";
import { toast } from "sonner";
import {
  LayoutDashboard,
  Users,
  User,
  Store,
  ShoppingCart,
  CreditCard,
  LogOut,
  Menu,
  Check,
  X,
  AlertCircle,
  PoundSterling,
  Package,
  TrendingUp,
  ChevronRight,
  Eye,
  FileText,
  Clock,
  CheckCircle,
  XCircle,
  Receipt,
  Tag,
  Plus,
  Trash2,
  Gift,
  Send,
  Edit,
  Save,
  MessageSquare,
  Star,
  Download,
  Sparkles,
  Search,
  RefreshCw,
  Key,
  Bell,
  Loader2,
  Unlink,
  Building2,
  Power,
  AlertTriangle,
  UserPlus,
  Briefcase,
  Mail,
} from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Switch } from "@/components/ui/switch";

const COMPANY_LOGO = "https://customer-assets.emergentagent.com/job_bizcommerce-19/artifacts/7hv4d1j9_LOGO%20PNG.png";

const AdminDashboard = () => {
  const { user, logout, token } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("overview");
  const [stats, setStats] = useState(null);
  const [merchants, setMerchants] = useState([]);
  const [users, setUsers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [billings, setBillings] = useState([]);
  const [promoCodes, setPromoCodes] = useState([]);
  const [adminInvoices, setAdminInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedMerchant, setSelectedMerchant] = useState(null);
  const [showDocumentsModal, setShowDocumentsModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [showPromoModal, setShowPromoModal] = useState(false);
  const [showAgreementModal, setShowAgreementModal] = useState(false);
  const [showViewAgreementModal, setShowViewAgreementModal] = useState(false);
  const [isEditingAgreement, setIsEditingAgreement] = useState(false);
  const [showMerchantProfileModal, setShowMerchantProfileModal] = useState(false);
  const [merchantProfileData, setMerchantProfileData] = useState(null);
  
  // Merchant management state
  const [merchantFilter, setMerchantFilter] = useState("all");
  const [merchantSearch, setMerchantSearch] = useState("");
  const [showMerchantDetail, setShowMerchantDetail] = useState(false);
  const [merchantDetailData, setMerchantDetailData] = useState(null);
  const [merchantTransactions, setMerchantTransactions] = useState([]);
  const [merchantSubscription, setMerchantSubscription] = useState(null);
  const [merchantDocuments, setMerchantDocuments] = useState([]);
  const [showEditMerchant, setShowEditMerchant] = useState(false);
  const [editMerchantForm, setEditMerchantForm] = useState({});
  const [merchantBookings, setMerchantBookings] = useState([]);
  const [selectedMerchantIds, setSelectedMerchantIds] = useState([]);
  const [bulkTogglingStores, setBulkTogglingStores] = useState(false);
  
  // Subscription management state
  const [allSubscriptions, setAllSubscriptions] = useState([]);
  const [showChangeSubModal, setShowChangeSubModal] = useState(false);
  const [selectedSubMerchant, setSelectedSubMerchant] = useState(null);
  const [newPlanId, setNewPlanId] = useState("");
  // V2 Add-ons management
  const [showManageAddonsModal, setShowManageAddonsModal] = useState(false);
  const [selectedAddonsForAdmin, setSelectedAddonsForAdmin] = useState([]);
  const [updatingAddons, setUpdatingAddons] = useState(false);
  
  // Fix Merchant Subscription Modal
  const [showFixSubscriptionModal, setShowFixSubscriptionModal] = useState(false);
  const [merchantToFix, setMerchantToFix] = useState(null);
  const [fixAddons, setFixAddons] = useState([]);
  const [fixingSubscription, setFixingSubscription] = useState(false);
  
  // Sync Connect Modal
  const [showSyncConnectModal, setShowSyncConnectModal] = useState(false);
  const [merchantToSyncConnect, setMerchantToSyncConnect] = useState(null);
  const [syncConnectAccountId, setSyncConnectAccountId] = useState("");
  const [syncingConnect, setSyncingConnect] = useState(false);
  
  // Stripe Data Sync State
  const [syncingStripeData, setSyncingStripeData] = useState(false);
  const [stripeSyncStatus, setStripeSyncStatus] = useState(null);

  // Stripe Data Sync Function
  const handleSyncStripeData = async () => {
    setSyncingStripeData(true);
    try {
      const response = await fetch(`${API}/admin/stripe-sync/full`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        toast.success(`Stripe sync complete! Customers: ${data.results?.customers?.synced || 0}, Subscriptions: ${data.results?.subscriptions?.synced || 0}, Invoices: ${data.results?.invoices?.synced || 0}`);
        // Refresh subscriptions list
        fetchAllData();
      } else {
        const errData = await response.json();
        toast.error(errData.detail || "Stripe sync failed");
      }
    } catch (error) {
      console.error("Stripe sync error:", error);
      toast.error("Failed to sync Stripe data");
    } finally {
      setSyncingStripeData(false);
    }
  };
  
  const openSyncConnectModal = (merchant) => {
    setMerchantToSyncConnect(merchant);
    setSyncConnectAccountId("");
    setShowSyncConnectModal(true);
  };

  const handleSyncConnect = async () => {
    if (!syncConnectAccountId.trim()) {
      toast.error("Please enter the Stripe Account ID");
      return;
    }
    
    // Validate that it's a Stripe account ID format (starts with acct_)
    if (!syncConnectAccountId.trim().startsWith("acct_")) {
      toast.error("Invalid format. Stripe Account ID must start with 'acct_' (e.g., acct_1T4eu70Y1jj5Y5q0)");
      return;
    }
    
    setSyncingConnect(true);
    let responseStatus = 0;
    try {
      const response = await fetch(`${API}/admin/merchants/${merchantToSyncConnect.user_id}/connect/sync`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ account_id: syncConnectAccountId.trim() })
      });
      
      responseStatus = response.status;
      
      // Read response as text first (safest approach to avoid body stream issues)
      let responseText = "";
      try {
        responseText = await response.text();
      } catch (readErr) {
        console.error("Failed to read response body:", readErr);
        // If we can't read the body, check if it was a success based on status
        if (response.ok) {
          toast.success("Sync completed (response truncated)");
          setShowSyncConnectModal(false);
          fetchAllData();
        } else {
          toast.error(`Request failed with status ${response.status}. Please try again.`);
        }
        return;
      }
      
      // Parse the JSON from text
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (parseErr) {
        console.error("Failed to parse JSON response:", responseText.substring(0, 200));
        // If response is not JSON, show it as error
        if (response.ok) {
          toast.success("Sync completed");
          setShowSyncConnectModal(false);
          fetchAllData();
        } else {
          toast.error(`Server error (${response.status}): ${responseText.substring(0, 100)}`);
        }
        return;
      }
      
      if (response.ok && data.success) {
        toast.success(data.message || "Connect account synced!");
        setShowSyncConnectModal(false);
        fetchAllData();
      } else {
        // Show the detailed error from the backend
        const errorMsg = data.detail || data.error || data.message || "Failed to sync Connect account";
        toast.error(errorMsg, { duration: 8000 });
        console.error("Sync Connect Error:", data);
      }
    } catch (error) {
      console.error("Sync Connect Exception:", error);
      if (responseStatus >= 200 && responseStatus < 300) {
        toast.success("Sync may have completed. Please refresh to check status.");
        setShowSyncConnectModal(false);
        fetchAllData();
      } else {
        toast.error(`Network error: ${error.message}. Please try again.`);
      }
    } finally {
      setSyncingConnect(false);
    }
  };

  const handleDisconnectStripe = async (merchantId, merchantEmail) => {
    if (!confirm(`Are you sure you want to disconnect Stripe Connect for ${merchantEmail}? The merchant will need to reconnect with a fresh OAuth flow.`)) {
      return;
    }
    
    try {
      const response = await fetch(`${API}/admin/merchants/${merchantId}/connect/disconnect`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
      
      let responseText = "";
      try {
        responseText = await response.text();
      } catch (e) {
        if (response.ok) {
          toast.success("Stripe Connect disconnected");
          fetchAllData();
        } else {
          toast.error("Failed to disconnect. Please try again.");
        }
        return;
      }
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        if (response.ok) {
          toast.success("Stripe Connect disconnected");
          fetchAllData();
        } else {
          toast.error("Server error");
        }
        return;
      }
      
      if (response.ok && data.success) {
        toast.success(data.message || "Stripe Connect disconnected! Merchant can now reconnect.");
        fetchAllData();
      } else {
        toast.error(data.detail || data.error || "Failed to disconnect Stripe Connect");
      }
    } catch (error) {
      console.error("Disconnect error:", error);
      toast.error(`Network error: ${error.message}`);
    }
  };

  const handleCreateConnect = async (merchantEmail, merchantName) => {
    if (!confirm(`Create a new Stripe Connect account for ${merchantEmail}? This will bypass OAuth and create an account directly.`)) {
      return;
    }
    
    try {
      const response = await fetch(`${API}/admin/merchants/create-connect`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          merchant_email: merchantEmail,
          business_name: merchantName
        })
      });
      
      let data;
      try {
        data = await response.json();
      } catch (e) {
        toast.error("Failed to parse response");
        return;
      }
      
      if (response.ok && data.success) {
        toast.success(`Created! Account: ${data.stripe_account_id}`, { duration: 10000 });
        if (data.onboarding_url) {
          // Show the onboarding URL
          const copyUrl = confirm(`Account created! Copy onboarding URL for merchant?\n\n${data.onboarding_url}`);
          if (copyUrl) {
            navigator.clipboard.writeText(data.onboarding_url);
            toast.success("URL copied to clipboard!");
          }
        }
        fetchAllData();
      } else {
        toast.error(data.detail || data.error || "Failed to create account", { duration: 8000 });
      }
    } catch (error) {
      console.error("Create Connect error:", error);
      toast.error(`Network error: ${error.message}`);
    }
  };

  const [agreementForm, setAgreementForm] = useState({
    agreement_content: "",
    terms_and_conditions: "",
    commission_rate: 2.0,
    transaction_fee: 0.5,
    payment_terms: "",
    effective_date: ""
  });
  const [merchantAgreement, setMerchantAgreement] = useState(null);
  const [showSignAgreementModal, setShowSignAgreementModal] = useState(false);
  const [adminSignature, setAdminSignature] = useState("");
  const [promoForm, setPromoForm] = useState({
    code: "",
    type: "percentage",
    discount_percent: 50,
    trial_days: 30,
    max_uses: "",
    expires_at: ""
  });
  
  // User management state
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  const [editUserForm, setEditUserForm] = useState({});
  const [editingUser, setEditingUser] = useState(null);
  
  // AI Credits management state
  const [showAddCreditsModal, setShowAddCreditsModal] = useState(false);
  const [selectedMerchantForCredits, setSelectedMerchantForCredits] = useState("");
  const [creditAmount, setCreditAmount] = useState(100);
  const [creditReason, setCreditReason] = useState("Admin bonus");
  
  // Plan management state
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [planForm, setPlanForm] = useState({
    plan: "basic",
    pos_enabled: true,
    crm_enabled: true,
    ai_enabled: true,
    services_enabled: true
  });

  useEffect(() => {
    fetchAllData();
  }, []);

  const fetchAllData = async () => {
    setLoading(true);
    const headers = { Authorization: `Bearer ${token}` };
    
    try {
      const [statsRes, merchantsRes, usersRes, ordersRes, transRes, billRes, promoRes, subsRes, invRes] = await Promise.all([
        fetch(`${API}/admin/stats`, { headers, credentials: "include" }),
        fetch(`${API}/admin/merchants`, { headers, credentials: "include" }),
        fetch(`${API}/admin/users`, { headers, credentials: "include" }),
        fetch(`${API}/admin/orders`, { headers, credentials: "include" }),
        fetch(`${API}/admin/transactions`, { headers, credentials: "include" }),
        fetch(`${API}/admin/billing`, { headers, credentials: "include" }),
        fetch(`${API}/admin/promo-codes`, { headers, credentials: "include" }),
        fetch(`${API}/admin/subscriptions`, { headers, credentials: "include" }),
        fetch(`${API}/admin/invoices`, { headers, credentials: "include" })
      ]);

      if (statsRes.ok) setStats(await statsRes.json());
      if (merchantsRes.ok) setMerchants(await merchantsRes.json());
      if (usersRes.ok) setUsers(await usersRes.json());
      if (ordersRes.ok) setOrders(await ordersRes.json());
      if (transRes.ok) setTransactions(await transRes.json());
      if (billRes.ok) setBillings(await billRes.json());
      if (promoRes.ok) {
        const promoData = await promoRes.json();
        setPromoCodes([...(promoData.default_codes || []), ...(promoData.promo_codes || [])]);
      }
      if (subsRes.ok) setAllSubscriptions(await subsRes.json());
      if (invRes.ok) { const invData = await invRes.json(); setAdminInvoices(invData.invoices || []); }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };


  const handleCreatePromoCode = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API}/admin/promo-codes`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          ...promoForm,
          max_uses: promoForm.max_uses ? parseInt(promoForm.max_uses) : null,
          expires_at: promoForm.expires_at || null
        })
      });

      if (response.ok) {
        toast.success("Promo code created!");
        setShowPromoModal(false);
        setPromoForm({ code: "", type: "percentage", discount_percent: 50, trial_days: 30, max_uses: "", expires_at: "" });
        fetchAllData();
      } else {
        const error = await response.json();
        toast.error(error.detail || "Failed to create promo code");
      }
    } catch (error) {
      toast.error("Failed to create promo code");
    }
  };

  const handleDeletePromoCode = async (promoId) => {
    if (!confirm("Are you sure you want to delete this promo code?")) return;
    
    try {
      const response = await fetch(`${API}/admin/promo-codes/${promoId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.ok) {
        toast.success("Promo code deleted!");
        fetchAllData();
      } else {
        toast.error("Failed to delete promo code");
      }
    } catch (error) {
      toast.error("Failed to delete promo code");
    }
  };

  const handleTogglePromoCode = async (promoId, currentActive) => {
    try {
      const response = await fetch(`${API}/admin/promo-codes/${promoId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ active: !currentActive })
      });

      if (response.ok) {
        toast.success(`Promo code ${!currentActive ? "activated" : "deactivated"}!`);
        fetchAllData();
      }
    } catch (error) {
      toast.error("Failed to update promo code");
    }
  };

  const viewMerchantDocuments = async (merchant) => {
    // Fetch fresh documents data from the dedicated endpoint for reliability
    try {
      const response = await fetch(`${API}/admin/merchants/${merchant.user_id}/documents`, {
        headers: { Authorization: `Bearer ${token}` },
        credentials: "include"
      });
      if (response.ok) {
        const data = await response.json();
        // Merge fresh documents into the merchant object
        const merchantWithDocs = {
          ...merchant,
          documents: data.documents || [],
          documents_count: data.documents?.length || 0
        };
        setSelectedMerchant(merchantWithDocs);
        console.log("Loaded merchant documents:", merchantWithDocs.documents);
      } else {
        // Fallback to existing data if API fails
        setSelectedMerchant(merchant);
      }
    } catch (error) {
      console.error("Error fetching merchant documents:", error);
      setSelectedMerchant(merchant);
    }
    setShowDocumentsModal(true);
  };

  const handleReviewDocument = async (documentId, status, notes = "") => {
    try {
      const response = await fetch(`${API}/admin/merchants/${selectedMerchant.user_id}/review-document`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}` 
        },
        credentials: "include",
        body: JSON.stringify({ document_id: documentId, status, review_notes: notes })
      });

      if (response.ok) {
        toast.success(`Document ${status === "approved" ? "approved" : "rejected"}`);
        
        // Refresh the selected merchant's documents immediately
        const docsResponse = await fetch(`${API}/admin/merchants/${selectedMerchant.user_id}/documents`, {
          headers: { Authorization: `Bearer ${token}` },
          credentials: "include"
        });
        if (docsResponse.ok) {
          const data = await docsResponse.json();
          setSelectedMerchant(prev => ({
            ...prev,
            documents: data.documents || [],
            documents_count: data.documents?.length || 0
          }));
        }
        
        // Also refresh the main merchants list
        fetchAllData();
      } else {
        toast.error("Failed to review document");
      }
    } catch (error) {
      toast.error("Failed to review document");
    }
  };

  const handleApproveMerchant = async (merchantId) => {
    try {
      const response = await fetch(`${API}/admin/merchants/${merchantId}/approve`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        credentials: "include"
      });

      if (response.ok) {
        toast.success("Merchant approved and notified via email!");
        setShowDocumentsModal(false);
        fetchAllData();
      } else {
        const error = await response.json();
        toast.error(error.detail || "Failed to approve merchant");
      }
    } catch (error) {
      toast.error("Failed to approve merchant");
    }
  };

  const openRejectModal = (merchant) => {
    setSelectedMerchant(merchant);
    setRejectReason("");
    setShowRejectModal(true);
  };

  const handleRejectMerchant = async () => {
    if (!selectedMerchant) return;
    
    try {
      const response = await fetch(`${API}/admin/merchants/${selectedMerchant.user_id}/reject`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}` 
        },
        credentials: "include",
        body: JSON.stringify({ reason: rejectReason })
      });

      if (response.ok) {
        toast.success("Merchant rejected and notified via email");
        setShowRejectModal(false);
        setShowDocumentsModal(false);
        fetchAllData();
      } else {
        toast.error("Failed to reject merchant");
      }
    } catch (error) {
      toast.error("Failed to reject merchant");
    }
  };

  // Send reminder email to merchant
  const [sendingReminder, setSendingReminder] = useState(null);
  
  const handleSendReminder = async (merchantId) => {
    setSendingReminder(merchantId);
    try {
      const response = await fetch(`${API}/admin/reminder/${merchantId}`, {
        method: "POST",
        headers: { 
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        credentials: "include"
      });
      
      if (response.ok) {
        const data = await response.json();
        toast.success(data.message || "Reminder sent successfully!");
      } else {
        const error = await response.json();
        toast.error(error.detail || "Failed to send reminder");
      }
    } catch (error) {
      toast.error("Failed to send reminder email");
    } finally {
      setSendingReminder(null);
    }
  };

  // Store Status Toggle Handler
  const handleToggleStoreStatus = async (merchant, newStatus) => {
    try {
      const response = await fetch(`${API}/admin/merchants/${merchant.user_id}/store-status`, {
        method: "PUT",
        headers: { 
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({ is_store_active: newStatus })
      });
      
      if (response.ok) {
        const data = await response.json();
        toast.success(`Store "${merchant.business_name || merchant.name}" set to ${newStatus ? 'online' : 'offline'}`);
        // Update local state
        setMerchants(prev => prev.map(m => 
          m.user_id === merchant.user_id ? { ...m, is_store_active: newStatus } : m
        ));
      } else {
        const error = await response.json();
        toast.error(error.detail || "Failed to update store status");
      }
    } catch (error) {
      toast.error("Failed to update store status");
    }
  };

  // Bulk Store Status Toggle Handler
  const handleBulkToggleStoreStatus = async (newStatus) => {
    if (selectedMerchantIds.length === 0) {
      toast.error("Please select merchants to update");
      return;
    }
    
    setBulkTogglingStores(true);
    let successCount = 0;
    let failCount = 0;
    
    for (const merchantId of selectedMerchantIds) {
      try {
        const response = await fetch(`${API}/admin/merchants/${merchantId}/store-status`, {
          method: "PUT",
          headers: { 
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          credentials: "include",
          body: JSON.stringify({ is_store_active: newStatus })
        });
        
        if (response.ok) {
          successCount++;
          setMerchants(prev => prev.map(m => 
            m.user_id === merchantId ? { ...m, is_store_active: newStatus } : m
          ));
        } else {
          failCount++;
        }
      } catch (error) {
        failCount++;
      }
    }
    
    setBulkTogglingStores(false);
    setSelectedMerchantIds([]);
    
    if (successCount > 0) {
      toast.success(`${successCount} store(s) set to ${newStatus ? 'online' : 'offline'}`);
    }
    if (failCount > 0) {
      toast.error(`${failCount} store(s) failed to update`);
    }
  };

  // Toggle merchant selection for bulk actions
  const toggleMerchantSelection = (merchantId) => {
    setSelectedMerchantIds(prev => 
      prev.includes(merchantId) 
        ? prev.filter(id => id !== merchantId)
        : [...prev, merchantId]
    );
  };

  // Select/Deselect all approved merchants
  const toggleSelectAllMerchants = () => {
    const approvedMerchants = merchants.filter(m => m.is_approved);
    if (selectedMerchantIds.length === approvedMerchants.length) {
      setSelectedMerchantIds([]);
    } else {
      setSelectedMerchantIds(approvedMerchants.map(m => m.user_id));
    }
  };

  // Merchant Agreement Functions
  const openAgreementModal = async (merchant) => {
    setSelectedMerchant(merchant);
    
    // Check if agreement exists
    try {
      const response = await fetch(`${API}/admin/merchants/${merchant.user_id}/agreement`, {
        headers: { Authorization: `Bearer ${token}` },
        credentials: "include"
      });
      if (response.ok) {
        const data = await response.json();
        setMerchantAgreement(data.agreement);
      }
    } catch (error) {
      setMerchantAgreement(null);
    }
    
    setAgreementForm({
      agreement_content: `This Platform Agreement ("Agreement") is entered into between VEYRONIX ("Platform") and ${merchant.business_name || merchant.name} ("Merchant").`,
      terms_and_conditions: `1. The Merchant agrees to comply with all Platform policies and guidelines.\n2. The Platform will process payments on behalf of the Merchant.\n3. Commission and fees will be deducted as specified below.`,
      commission_rate: 2.0,
      transaction_fee: 0.5,
      payment_terms: "Payouts will be processed weekly or daily based on merchant preference.",
      effective_date: new Date().toISOString().split('T')[0]
    });
    setShowAgreementModal(true);
  };

  // View/Edit Agreement Modal
  const openViewAgreementModal = async (merchant) => {
    setSelectedMerchant(merchant);
    setIsEditingAgreement(false);
    
    try {
      const response = await fetch(`${API}/admin/merchants/${merchant.user_id}/agreement`, {
        headers: { Authorization: `Bearer ${token}` },
        credentials: "include"
      });
      if (response.ok) {
        const data = await response.json();
        if (data.agreement) {
          setMerchantAgreement(data.agreement);
          setAgreementForm({
            agreement_content: data.agreement.agreement_content || "",
            terms_and_conditions: data.agreement.terms_and_conditions || "",
            commission_rate: data.agreement.commission_rate || 2.0,
            transaction_fee: data.agreement.transaction_fee || 0.5,
            payment_terms: data.agreement.payment_terms || "",
            effective_date: data.agreement.effective_date || ""
          });
          setShowViewAgreementModal(true);
        } else {
          toast.info("No agreement found for this merchant");
        }
      }
    } catch (error) {
      toast.error("Failed to fetch agreement");
    }
  };

  // Open Merchant Profile Modal
  const openMerchantProfileModal = async (merchant) => {
    setSelectedMerchant(merchant);
    try {
      const response = await fetch(`${API}/admin/merchants/${merchant.user_id}/profile`, {
        headers: { Authorization: `Bearer ${token}` },
        credentials: "include"
      });
      if (response.ok) {
        const data = await response.json();
        setMerchantProfileData(data);
        setShowMerchantProfileModal(true);
      } else {
        toast.error("Failed to fetch merchant profile");
      }
    } catch (error) {
      toast.error("Failed to fetch merchant profile");
    }
  };

  const handleUpdateAgreement = async () => {
    if (!selectedMerchant || !merchantAgreement) return;
    
    try {
      const response = await fetch(`${API}/admin/merchants/${selectedMerchant.user_id}/agreement/update`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        credentials: "include",
        body: JSON.stringify(agreementForm)
      });
      
      if (response.ok) {
        toast.success("Agreement updated successfully!");
        setIsEditingAgreement(false);
        // Refresh the agreement data
        const updatedResponse = await fetch(`${API}/admin/merchants/${selectedMerchant.user_id}/agreement`, {
          headers: { Authorization: `Bearer ${token}` },
          credentials: "include"
        });
        if (updatedResponse.ok) {
          const data = await updatedResponse.json();
          setMerchantAgreement(data.agreement);
        }
      } else {
        const error = await response.json();
        toast.error(error.detail || "Failed to update agreement");
      }
    } catch (error) {
      toast.error("Failed to update agreement");
    }
  };

  const handleInitiateAgreement = async (e) => {
    e.preventDefault();
    if (!selectedMerchant) return;
    
    try {
      const response = await fetch(`${API}/admin/merchants/${selectedMerchant.user_id}/agreement/initiate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        credentials: "include",
        body: JSON.stringify(agreementForm)
      });
      
      if (response.ok) {
        toast.success("Agreement initiated and sent to merchant for signing!");
        setShowAgreementModal(false);
        fetchAllData();
      } else {
        const error = await response.json();
        toast.error(error.detail || "Failed to initiate agreement");
      }
    } catch (error) {
      toast.error("Failed to initiate agreement");
    }
  };

  const openSignAgreementModal = async (merchant) => {
    setSelectedMerchant(merchant);
    
    // Fetch agreement
    try {
      const response = await fetch(`${API}/admin/merchants/${merchant.user_id}/agreement`, {
        headers: { Authorization: `Bearer ${token}` },
        credentials: "include"
      });
      if (response.ok) {
        const data = await response.json();
        setMerchantAgreement(data.agreement);
        if (data.agreement?.status === "pending_admin") {
          setShowSignAgreementModal(true);
        } else {
          toast.info("Agreement is not ready for admin signature");
        }
      }
    } catch (error) {
      toast.error("Failed to fetch agreement");
    }
  };

  const handleAdminSignAgreement = async () => {
    if (!selectedMerchant || !adminSignature) {
      toast.error("Please provide your signature");
      return;
    }
    
    try {
      const response = await fetch(`${API}/admin/merchants/${selectedMerchant.user_id}/agreement/sign`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        credentials: "include",
        body: JSON.stringify({ signature_data: adminSignature })
      });
      
      if (response.ok) {
        toast.success("Agreement signed! Both parties have now signed the agreement.");
        setShowSignAgreementModal(false);
        setAdminSignature("");
        fetchAllData();
      } else {
        const error = await response.json();
        toast.error(error.detail || "Failed to sign agreement");
      }
    } catch (error) {
      toast.error("Failed to sign agreement");
    }
  };

  // Subscription management functions
  const handleChangeSubscriptionPlan = async () => {
    if (!selectedSubMerchant || !newPlanId) {
      toast.error("Please select a plan");
      return;
    }
    
    try {
      const response = await fetch(`${API}/admin/subscriptions/${selectedSubMerchant.user_id}/plan`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        credentials: "include",
        body: JSON.stringify({ plan_id: newPlanId })
      });
      
      if (response.ok) {
        toast.success("Subscription plan updated successfully");
        setShowChangeSubModal(false);
        setSelectedSubMerchant(null);
        setNewPlanId("");
        fetchAllData();
      } else {
        const error = await response.json();
        toast.error(error.detail || "Failed to update subscription");
      }
    } catch (error) {
      toast.error("Failed to update subscription");
    }
  };

  const handleCancelSubscription = async (userId, immediate = false) => {
    if (!confirm(`Are you sure you want to ${immediate ? "immediately cancel" : "cancel at period end"} this subscription?`)) return;
    
    try {
      const response = await fetch(`${API}/admin/subscriptions/${userId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        credentials: "include",
        body: JSON.stringify({ immediate })
      });
      
      if (response.ok) {
        toast.success(immediate ? "Subscription cancelled immediately" : "Subscription will cancel at period end");
        fetchAllData();
      } else {
        const error = await response.json();
        toast.error(error.detail || "Failed to cancel subscription");
      }
    } catch (error) {
      toast.error("Failed to cancel subscription");
    }
  };

  // V2 Update merchant add-ons
  const handleUpdateMerchantAddons = async () => {
    if (!selectedSubMerchant) return;
    
    setUpdatingAddons(true);
    try {
      const response = await fetch(`${API}/admin/merchants/${selectedSubMerchant.user_id}/subscription/addons`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        credentials: "include",
        body: JSON.stringify({ addons: selectedAddonsForAdmin })
      });
      
      if (response.ok) {
        const data = await response.json();
        toast.success(data.message || "Add-ons updated successfully");
        setShowManageAddonsModal(false);
        fetchAllData();
      } else {
        const error = await response.json();
        toast.error(error.detail || "Failed to update add-ons");
      }
    } catch (error) {
      toast.error("Failed to update add-ons");
    } finally {
      setUpdatingAddons(false);
    }
  };

  const toggleAddonForAdmin = (addonId) => {
    setSelectedAddonsForAdmin(prev => 
      prev.includes(addonId) 
        ? prev.filter(id => id !== addonId)
        : [...prev, addonId]
    );
  };

  // Fix/Sync Merchant Subscription
  const openFixSubscriptionModal = (merchant) => {
    setMerchantToFix(merchant);
    setFixAddons([]);
    setShowFixSubscriptionModal(true);
  };

  const handleFixSubscription = async () => {
    if (!merchantToFix) return;
    
    setFixingSubscription(true);
    try {
      const response = await fetch(`${API}/admin/merchants/${merchantToFix.user_id}/sync-subscription`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        credentials: "include",
        body: JSON.stringify({ 
          manual_approve: true, 
          addons: fixAddons 
        })
      });
      
      if (response.ok) {
        const data = await response.json();
        toast.success(data.message || "Merchant subscription fixed successfully!");
        setShowFixSubscriptionModal(false);
        fetchAllData();
      } else {
        const error = await response.json();
        toast.error(error.detail || "Failed to fix subscription");
      }
    } catch (error) {
      toast.error("Failed to fix subscription");
    } finally {
      setFixingSubscription(false);
    }
  };

  const toggleFixAddon = (addonId) => {
    setFixAddons(prev => 
      prev.includes(addonId) 
        ? prev.filter(id => id !== addonId)
        : [...prev, addonId]
    );
  };

  const handleUpdateBillingStatus = async (billingId, status) => {
    try {
      const response = await fetch(`${API}/admin/billing/${billingId}/status`, {
        method: "PATCH",
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}` 
        },
        credentials: "include",
        body: JSON.stringify({ status })
      });

      if (response.ok) {
        toast.success(`Billing marked as ${status}`);
        fetchAllData();
      } else {
        toast.error("Failed to update billing status");
      }
    } catch (error) {
      toast.error("Failed to update billing status");
    }
  };

  // ===== MERCHANT MANAGEMENT FUNCTIONS =====
  
  // View merchant details
  const viewMerchantDetail = async (merchant) => {
    setMerchantDetailData(merchant);
    setShowMerchantDetail(true);
    setMerchantDocuments([]);
    
    // Fetch merchant's transactions
    try {
      const transRes = await fetch(`${API}/admin/merchants/${merchant.user_id}/transactions`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (transRes.ok) {
        const data = await transRes.json();
        setMerchantTransactions(data.pos_transactions || []);
        setMerchantBookings(data.bookings || []);
      }
    } catch (e) {
      console.error("Error fetching merchant transactions:", e);
    }
    
    // Fetch merchant documents
    try {
      const docsRes = await fetch(`${API}/admin/merchants/${merchant.user_id}/documents`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (docsRes.ok) {
        const data = await docsRes.json();
        setMerchantDocuments(data.documents || data || []);
      }
    } catch (e) {
      console.error("Error fetching merchant documents:", e);
    }
    
    // Fetch subscription info
    try {
      const subRes = await fetch(`${API}/admin/merchants/${merchant.user_id}/subscription`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (subRes.ok) {
        const data = await subRes.json();
        setMerchantSubscription(data);
      }
    } catch (e) {
      console.error("Error fetching subscription:", e);
    }
  };
  
  // Edit merchant
  const openEditMerchant = (merchant) => {
    setEditMerchantForm({
      first_name: merchant.first_name || "",
      last_name: merchant.last_name || "",
      business_name: merchant.business_name || "",
      email: merchant.email || "",
      phone: merchant.phone || "",
      verification_status: merchant.verification_status || "pending"
    });
    setSelectedMerchant(merchant);
    setShowEditMerchant(true);
  };
  
  const handleUpdateMerchant = async () => {
    try {
      const response = await fetch(`${API}/admin/merchants/${selectedMerchant.user_id}`, {
        method: "PUT",
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}` 
        },
        body: JSON.stringify(editMerchantForm)
      });
      
      if (response.ok) {
        toast.success("Merchant updated");
        fetchAllData();
        setShowEditMerchant(false);
      } else {
        const err = await response.json();
        toast.error(err.detail || "Failed to update merchant");
      }
    } catch (e) {
      toast.error("Failed to update merchant");
    }
  };
  
  // Delete merchant (soft delete)
  // Toggle CRM/POS feature for a merchant
  const handleToggleFeature = async (merchantId, feature, currentValue) => {
    try {
      const response = await fetch(`${API}/admin/merchants/${merchantId}/toggle-feature`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        credentials: "include",
        body: JSON.stringify({ feature, enabled: !currentValue })
      });
      if (response.ok) {
        toast.success(`${feature.toUpperCase()} ${!currentValue ? "enabled" : "disabled"}`);
        fetchAllData();
      } else {
        const err = await response.json();
        toast.error(err.detail || "Failed to toggle feature");
      }
    } catch (e) {
      toast.error("Failed to toggle feature");
    }
  };


  const handleDeleteMerchant = async (merchantId) => {
    if (!confirm("Are you sure you want to DELETE this merchant? This action cannot be undone.")) return;
    
    try {
      const response = await fetch(`${API}/admin/merchants/${merchantId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.ok) {
        toast.success("Merchant deleted");
        fetchAllData();
        setShowMerchantDetail(false);
      } else {
        const err = await response.json();
        toast.error(err.detail || "Failed to delete merchant");
      }
    } catch (e) {
      toast.error("Failed to delete merchant");
    }
  };

  // Permanently delete merchant and ALL data
  const handlePermanentDeleteMerchant = async (merchantId, merchantEmail) => {
    if (!confirm(`⚠️ PERMANENT DELETE\n\nThis will permanently delete merchant "${merchantEmail}" and ALL their data:\n- User account\n- Platform agreements\n- Documents\n- Products, Orders, Invoices\n\nThis action CANNOT be undone. Continue?`)) return;
    
    try {
      const response = await fetch(`${API}/admin/merchants/${merchantId}/permanent`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.ok) {
        const result = await response.json();
        toast.success(`Merchant permanently deleted. ${JSON.stringify(result.deleted_data)}`);
        fetchAllData();
        setShowMerchantDetail(false);
      } else {
        const err = await response.json();
        toast.error(err.detail || "Failed to permanently delete merchant");
      }
    } catch (e) {
      toast.error("Failed to permanently delete merchant");
    }
  };

  // Reset merchant agreement (delete agreement so admin can re-initiate)
  const handleResetAgreement = async (merchantId) => {
    if (!confirm("This will delete the merchant's platform agreement. You can then re-initiate a new agreement. Continue?")) return;
    
    try {
      const response = await fetch(`${API}/admin/merchants/${merchantId}/reset-agreement`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.ok) {
        const result = await response.json();
        toast.success(result.message);
        fetchAllData();
        // Refresh agreement data
        if (selectedMerchant?.user_id === merchantId) {
          setMerchantAgreement(null);
        }
      } else {
        const err = await response.json();
        toast.error(err.detail || "Failed to reset agreement");
      }
    } catch (e) {
      toast.error("Failed to reset agreement");
    }
  };
  
  // Remove merchant (soft delete) - legacy
  const handleRemoveMerchant = async (merchantId) => {
    if (!confirm("Are you sure you want to remove this merchant? This will deactivate their account.")) return;
    
    try {
      const response = await fetch(`${API}/admin/merchants/${merchantId}/remove`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.ok) {
        toast.success("Merchant removed");
        fetchAllData();
        setShowMerchantDetail(false);
      } else {
        const err = await response.json();
        toast.error(err.detail || "Failed to remove merchant");
      }
    } catch (e) {
      toast.error("Failed to remove merchant");
    }
  };

  // Send password reset email to user
  const handleSendResetPassword = async (userId, userEmail) => {
    if (!confirm(`Send password reset email to ${userEmail}?`)) return;
    
    try {
      const response = await fetch(`${API}/admin/users/${userId}/send-reset-password`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.ok) {
        toast.success(`Password reset email sent to ${userEmail}`);
      } else {
        const err = await response.json();
        toast.error(err.detail || "Failed to send reset email");
      }
    } catch (e) {
      toast.error("Failed to send reset email");
    }
  };
  
  // Bulk remove test merchants
  const handleBulkRemoveTestMerchants = async () => {
    const testMerchants = merchants.filter(m => 
      m.email?.includes("test") || 
      m.business_name?.toLowerCase().includes("test") ||
      m.merchant_status === "test"
    );
    
    if (testMerchants.length === 0) {
      toast.info("No test merchants found");
      return;
    }
    
    if (!confirm(`This will remove ${testMerchants.length} test merchant(s). Continue?`)) return;
    
    try {
      const response = await fetch(`${API}/admin/merchants/bulk-remove-test`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.ok) {
        const result = await response.json();
        toast.success(`Removed ${result.removed_count} test merchants`);
        fetchAllData();
      } else {
        toast.error("Failed to remove test merchants");
      }
    } catch (e) {
      toast.error("Failed to remove test merchants");
    }
  };

  // Seed demo accounts
  const handleSeedDemoAccounts = async () => {
    if (!confirm("This will create the demo merchant account (demo@veyronix.com / Demo123!) with sample products. Continue?")) return;
    
    try {
      const response = await fetch(`${API}/admin/seed-demo-accounts`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.ok) {
        const result = await response.json();
        if (result.success) {
          toast.success("Demo accounts seeded successfully!");
          if (result.credentials?.demo_merchant) {
            toast.info(`Login: ${result.credentials.demo_merchant.email} / ${result.credentials.demo_merchant.password}`);
          }
        } else {
          toast.warning("Seed completed with some issues");
        }
        fetchAllData();
      } else {
        const err = await response.json();
        toast.error(err.detail || "Failed to seed demo accounts");
      }
    } catch (e) {
      toast.error("Failed to seed demo accounts");
    }
  };
  
  // Toggle POS access
  const handleTogglePosAccess = async (merchantId, enabled) => {
    try {
      const response = await fetch(`${API}/admin/merchants/${merchantId}/pos-access`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ pos_enabled: enabled })
      });
      
      if (response.ok) {
        toast.success(`POS access ${enabled ? "enabled" : "disabled"}`);
        fetchAllData();
      } else {
        toast.error("Failed to update POS access");
      }
    } catch (e) {
      toast.error("Failed to update POS access");
    }
  };
  
  // Update subscription (upgrade/downgrade)
  const handleUpdateSubscription = async (merchantId, action, data = {}) => {
    try {
      const response = await fetch(`${API}/admin/merchants/${merchantId}/subscription/${action}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
      });
      
      if (response.ok) {
        toast.success(`Subscription ${action} successful`);
        fetchAllData();
      } else {
        const err = await response.json();
        toast.error(err.detail || `Failed to ${action} subscription`);
      }
    } catch (e) {
      toast.error(`Failed to ${action} subscription`);
    }
  };
  
  // Contact merchant
  const handleContactMerchant = (merchant, method = "email") => {
    if (method === "email" && merchant.email) {
      window.open(`mailto:${merchant.email}?subject=Veyronix Platform - Regarding Your Account`);
    } else if (method === "phone" && merchant.phone) {
      window.open(`tel:${merchant.phone}`);
    } else {
      toast.info("Contact information not available");
    }
  };
  
  // Filter merchants
  const getFilteredMerchants = () => {
    let filtered = merchants;
    
    // Apply status filter
    if (merchantFilter !== "all") {
      if (merchantFilter === "active") {
        filtered = filtered.filter(m => m.merchant_status === "active" || m.merchant_status === "approved");
      } else if (merchantFilter === "trial") {
        filtered = filtered.filter(m => m.subscription_plan === "trial" || m.is_trial);
      } else if (merchantFilter === "cancelled") {
        filtered = filtered.filter(m => m.merchant_status === "cancelled" || m.merchant_status === "suspended");
      } else if (merchantFilter === "test") {
        filtered = filtered.filter(m => 
          m.email?.includes("test") || 
          m.business_name?.toLowerCase().includes("test") ||
          m.merchant_status === "test"
        );
      }
    }
    
    // Apply search
    if (merchantSearch) {
      const search = merchantSearch.toLowerCase();
      filtered = filtered.filter(m => 
        m.name?.toLowerCase().includes(search) ||
        m.email?.toLowerCase().includes(search) ||
        m.business_name?.toLowerCase().includes(search)
      );
    }
    
    return filtered;
  };

  // ===== USER MANAGEMENT FUNCTIONS =====
  
  // Open edit user modal
  const openEditUserModal = (u) => {
    setEditingUser(u);
    setEditUserForm({
      name: u.name || "",
      email: u.email || "",
      role: u.role || "customer",
      is_approved: u.is_approved !== false
    });
    setShowEditUserModal(true);
  };
  
  // Update user
  const handleUpdateUser = async () => {
    if (!editingUser) return;
    
    try {
      const response = await fetch(`${API}/admin/users/${editingUser.user_id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(editUserForm)
      });
      
      if (response.ok) {
        toast.success("User updated successfully");
        setShowEditUserModal(false);
        setEditingUser(null);
        fetchAllData();
      } else {
        const err = await response.json();
        toast.error(err.detail || "Failed to update user");
      }
    } catch (e) {
      toast.error("Failed to update user");
    }
  };
  
  // Delete user
  const handleDeleteUser = async (userId) => {
    if (!confirm("Are you sure you want to delete this user? This action cannot be undone.")) return;
    
    try {
      const response = await fetch(`${API}/admin/users/${userId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.ok) {
        toast.success("User deleted");
        fetchAllData();
      } else {
        const err = await response.json();
        toast.error(err.detail || "Failed to delete user");
      }
    } catch (e) {
      toast.error("Failed to delete user");
    }
  };
  
  // ===== AI CREDITS MANAGEMENT FUNCTIONS =====
  
  // Add AI credits to merchant
  const handleAddAICredits = async () => {
    if (!selectedMerchantForCredits || creditAmount <= 0) return;
    
    try {
      const response = await fetch(`${API}/admin/merchants/${selectedMerchantForCredits}/add-ai-credits`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          amount: creditAmount,
          reason: creditReason
        })
      });
      
      if (response.ok) {
        const data = await response.json();
        toast.success(`Added ${creditAmount} AI credits! New balance: ${data.new_balance}`);
        setShowAddCreditsModal(false);
        setSelectedMerchantForCredits("");
        setCreditAmount(100);
        setCreditReason("Admin bonus");
      } else {
        const err = await response.json();
        toast.error(err.detail || "Failed to add credits");
      }
    } catch (e) {
      toast.error("Failed to add credits");
    }
  };
  
  // ===== PLAN MANAGEMENT FUNCTIONS =====
  
  // Open plan modal for merchant
  const openPlanModal = (merchant) => {
    setSelectedMerchant(merchant);
    setPlanForm({
      plan: merchant.selected_plan || merchant.subscription_plan || "basic",
      pos_enabled: merchant.pos_enabled !== false,
      crm_enabled: merchant.crm_enabled !== false,
      ai_enabled: merchant.ai_enabled !== false,
      services_enabled: merchant.services_enabled !== false
    });
    setShowPlanModal(true);
  };
  
  // Save plan changes
  const handleSavePlanChanges = async () => {
    if (!selectedMerchant) return;
    
    try {
      const response = await fetch(`${API}/admin/merchants/${selectedMerchant.user_id}/plan`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(planForm)
      });
      
      if (response.ok) {
        toast.success("Plan and access settings saved!");
        setShowPlanModal(false);
        fetchAllData();
      } else {
        const err = await response.json();
        toast.error(err.detail || "Failed to save plan");
      }
    } catch (e) {
      toast.error("Failed to save plan");
    }
  };
  
  // ===== APPLICATION MANAGEMENT FUNCTIONS =====
  
  // Reject application (allow reapply)
  const handleRejectApplication = async (merchantId, reason) => {
    try {
      const response = await fetch(`${API}/admin/merchants/${merchantId}/reject-application`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ reason: reason || "Application rejected" })
      });
      
      if (response.ok) {
        toast.success("Application rejected. Merchant can reapply.");
        setShowRejectModal(false);
        fetchAllData();
      } else {
        const err = await response.json();
        toast.error(err.detail || "Failed to reject application");
      }
    } catch (e) {
      toast.error("Failed to reject application");
    }
  };

  const menuItems = [
    { id: "overview", label: "Overview", icon: LayoutDashboard },
    { id: "merchants", label: "Merchants", icon: Store },
    { id: "subscriptions", label: "Subscriptions", icon: RefreshCw },
    { id: "invoices", label: "Invoices", icon: FileText },
    { id: "billing", label: "Billing", icon: Receipt },
    { id: "promo-codes", label: "Promo Codes", icon: Tag },
    { id: "users", label: "All Users", icon: Users },
    { id: "orders", label: "Orders", icon: ShoppingCart },
    { id: "transactions", label: "Transactions", icon: CreditCard },
    { id: "feedback", label: "Feedback", icon: MessageSquare },
    { id: "ai-credits", label: "AI Credits", icon: Sparkles },
    { id: "commerce", label: "Commerce Management", icon: Briefcase },
    { id: "pulse-launch", label: "PULSE Launch Subscribers", icon: Mail },
    { id: "seo", label: "Auto-SEO", icon: Search, link: "/admin/seo" }
  ];

  const pendingMerchants = merchants.filter(m => m.merchant_status === "pending_approval");
  const pendingDocuments = merchants.filter(m => m.merchant_status === "pending_documents");
  const pendingPayment = merchants.filter(m => m.merchant_status === "pending_payment");

  return (
    <div className="min-h-screen bg-slate-50 flex">
      {/* Sidebar */}
      <aside className={`fixed lg:static inset-y-0 left-0 z-50 w-64 bg-slate-900 transform transition-transform duration-200 ${sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}>
        <div className="flex flex-col h-full">
          <div className="p-6 border-b border-slate-800">
            <Link to="/" className="flex items-center gap-3">
              <img src={COMPANY_LOGO} alt="V" className="h-10 w-auto brightness-0 invert" />
              <div className="h-8 w-px bg-white/40" />
              <span className="text-white font-brand text-lg font-bold">VEYRONIX</span>
            </Link>
            <p className="text-xs text-slate-500 mt-2">Admin Panel</p>
          </div>

          <nav className="flex-1 p-4 space-y-1">
            {menuItems.map(item => (
              item.link ? (
                <Link
                  key={item.id}
                  to={item.link}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors text-slate-400 hover:text-white hover:bg-slate-800`}
                  data-testid={`admin-menu-${item.id}`}
                >
                  <item.icon className="h-5 w-5" />
                  {item.label}
                </Link>
              ) : (
                <button
                  key={item.id}
                  onClick={() => { setActiveTab(item.id); setSidebarOpen(false); }}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors ${
                    activeTab === item.id
                      ? "bg-indigo-600 text-white"
                      : "text-slate-400 hover:text-white hover:bg-slate-800"
                  }`}
                  data-testid={`admin-menu-${item.id}`}
                >
                  <item.icon className="h-5 w-5" />
                  {item.label}
                  {item.id === "merchants" && pendingMerchants.length > 0 && (
                    <span className="ml-auto bg-amber-500 text-white text-xs px-2 py-0.5 rounded-full">
                      {pendingMerchants.length}
                    </span>
                  )}
                </button>
              )
            ))}
          </nav>

          <div className="p-4 border-t border-slate-800">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-indigo-600 flex items-center justify-center">
                <span className="font-heading font-bold text-white">
                  {user?.name?.charAt(0)?.toUpperCase()}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium text-white text-sm truncate">{user?.name}</p>
                <p className="text-xs text-slate-500">Administrator</p>
              </div>
            </div>
            <Button
              variant="outline"
              onClick={handleLogout}
              className="w-full rounded-full text-sm border-slate-700 text-slate-300 hover:text-white hover:bg-slate-800"
              data-testid="admin-logout-btn"
            >
              <LogOut className="h-4 w-4 mr-2" />
              Sign Out
            </Button>
          </div>
        </div>
      </aside>

      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main content */}
      <main className="flex-1 min-w-0">
        {/* Header */}
        <header className="sticky top-0 z-30 bg-white border-b border-slate-200 px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <button
                className="lg:hidden p-2 -ml-2"
                onClick={() => setSidebarOpen(true)}
              >
                <Menu className="h-6 w-6" />
              </button>
              <h1 className="font-heading text-xl font-bold text-slate-900" data-testid="admin-dashboard">
                {menuItems.find(m => m.id === activeTab)?.label || "Admin Dashboard"}
              </h1>
            </div>
            <Link to="/store">
              <Button variant="outline" className="rounded-full text-sm">
                View Store
                <ChevronRight className="h-4 w-4 ml-1" />
              </Button>
            </Link>
          </div>
        </header>

        {/* Content */}
        <div className="p-6">
          {loading ? (
            <div className="flex items-center justify-center py-20">
              <div className="w-12 h-12 border-4 border-indigo-500/30 border-t-indigo-500 rounded-full animate-spin" />
            </div>
          ) : activeTab === "overview" ? (
            /* Overview */
            <div className="space-y-6">
              {/* Pending Approvals Alert */}
              {pendingMerchants.length > 0 && (
                <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
                    <AlertCircle className="h-5 w-5 text-amber-600" />
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-amber-900">{pendingMerchants.length} merchants pending approval</p>
                    <p className="text-sm text-amber-700">Review and approve new merchant registrations.</p>
                  </div>
                  <Button
                    onClick={() => setActiveTab("merchants")}
                    className="bg-amber-600 hover:bg-amber-700 rounded-full"
                    data-testid="review-merchants-btn"
                  >
                    Review Now
                  </Button>
                </div>
              )}

              {/* Key Metrics */}
              <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
                <div className="bg-white rounded-xl border border-slate-200 p-5">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-indigo-100 flex items-center justify-center">
                      <Store className="h-5 w-5 text-indigo-600" />
                    </div>
                    <div>
                      <p className="text-2xl font-heading font-bold text-slate-900">{stats?.total_merchants || 0}</p>
                      <p className="text-xs text-slate-500">Total Merchants</p>
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-xl border border-slate-200 p-5">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center">
                      <CheckCircle className="h-5 w-5 text-emerald-600" />
                    </div>
                    <div>
                      <p className="text-2xl font-heading font-bold text-slate-900">{stats?.active_stores || 0}</p>
                      <p className="text-xs text-slate-500">Active Stores</p>
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-xl border border-slate-200 p-5">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
                      <ShoppingCart className="h-5 w-5 text-blue-600" />
                    </div>
                    <div>
                      <p className="text-2xl font-heading font-bold text-slate-900">{stats?.orders_today || 0}</p>
                      <p className="text-xs text-slate-500">Orders Today</p>
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-xl border border-slate-200 p-5">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-cyan-100 flex items-center justify-center">
                      <PoundSterling className="h-5 w-5 text-cyan-600" />
                    </div>
                    <div>
                      <p className="text-2xl font-heading font-bold text-slate-900">£{stats?.revenue_30d?.toFixed(2) || "0.00"}</p>
                      <p className="text-xs text-slate-500">Revenue (30d)</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Alerts Section */}
              {(stats?.payment_failures > 0 || stats?.pending_documents > 0 || stats?.pending_merchants > 0) && (
                <div className="grid sm:grid-cols-3 gap-4">
                  {stats?.payment_failures > 0 && (
                    <div className="bg-red-50 border border-red-200 rounded-xl p-4 flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
                        <AlertTriangle className="h-5 w-5 text-red-600" />
                      </div>
                      <div>
                        <p className="font-semibold text-red-800">{stats.payment_failures} Payment Failures</p>
                        <p className="text-xs text-red-600">In the last 7 days</p>
                      </div>
                    </div>
                  )}
                  {stats?.pending_documents > 0 && (
                    <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
                        <FileText className="h-5 w-5 text-amber-600" />
                      </div>
                      <div>
                        <p className="font-semibold text-amber-800">{stats.pending_documents} Documents Pending</p>
                        <p className="text-xs text-amber-600">Require review</p>
                      </div>
                    </div>
                  )}
                  {stats?.pending_merchants > 0 && (
                    <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                        <UserPlus className="h-5 w-5 text-blue-600" />
                      </div>
                      <div>
                        <p className="font-semibold text-blue-800">{stats.pending_merchants} Pending Merchants</p>
                        <p className="text-xs text-blue-600">Awaiting approval</p>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Quick Actions - Stripe Sync */}
              <div className="bg-gradient-to-r from-indigo-500 to-violet-600 rounded-xl p-6 text-white" data-testid="stripe-sync-card">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                      <RefreshCw className="h-6 w-6" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg">Stripe Data Sync</h3>
                      <p className="text-indigo-100 text-sm mt-1">
                        Sync customers, subscriptions, and invoices from Stripe to keep dashboards up-to-date.
                      </p>
                    </div>
                  </div>
                  <Button
                    onClick={handleSyncStripeData}
                    disabled={syncingStripeData}
                    className="bg-white text-indigo-600 hover:bg-indigo-50"
                    data-testid="overview-sync-stripe-btn"
                  >
                    {syncingStripeData ? (
                      <>
                        <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                        Syncing...
                      </>
                    ) : (
                      <>
                        <RefreshCw className="h-4 w-4 mr-2" />
                        Sync Now
                      </>
                    )}
                  </Button>
                </div>
              </div>

              {/* Charts Row */}
              <div className="grid lg:grid-cols-2 gap-6">
                {/* New Merchants Weekly */}
                <div className="bg-white rounded-xl border border-slate-200 p-6">
                  <h3 className="font-heading font-semibold text-slate-900 mb-4">New Merchants (Weekly)</h3>
                  <div className="h-48 flex items-end justify-between gap-2">
                    {stats?.weekly_merchants?.map((week, idx) => {
                      const maxCount = Math.max(...(stats.weekly_merchants?.map(w => w.count) || [1]), 1);
                      const height = (week.count / maxCount) * 100;
                      return (
                        <div key={idx} className="flex-1 flex flex-col items-center gap-1">
                          <span className="text-xs text-slate-500">{week.count}</span>
                          <div 
                            className="w-full bg-indigo-500 rounded-t-md transition-all"
                            style={{ height: `${Math.max(height, 5)}%` }}
                          />
                          <span className="text-xs text-slate-400">{week.week.replace('Week ', 'W')}</span>
                        </div>
                      );
                    }) || (
                      <p className="text-slate-400 text-center w-full">No data</p>
                    )}
                  </div>
                </div>

                {/* Orders Trend Weekly */}
                <div className="bg-white rounded-xl border border-slate-200 p-6">
                  <h3 className="font-heading font-semibold text-slate-900 mb-4">Orders Trend (Weekly)</h3>
                  <div className="h-48 flex items-end justify-between gap-2">
                    {stats?.weekly_orders?.map((week, idx) => {
                      const maxCount = Math.max(...(stats.weekly_orders?.map(w => w.count) || [1]), 1);
                      const height = (week.count / maxCount) * 100;
                      return (
                        <div key={idx} className="flex-1 flex flex-col items-center gap-1">
                          <span className="text-xs text-slate-500">{week.count}</span>
                          <div 
                            className="w-full bg-emerald-500 rounded-t-md transition-all"
                            style={{ height: `${Math.max(height, 5)}%` }}
                          />
                          <span className="text-xs text-slate-400">{week.week.replace('Week ', 'W')}</span>
                        </div>
                      );
                    }) || (
                      <p className="text-slate-400 text-center w-full">No data</p>
                    )}
                  </div>
                </div>
              </div>

              {/* Recent Activity */}
              <div className="grid lg:grid-cols-2 gap-6">
                <div className="bg-white rounded-xl border border-slate-200 p-6">
                  <h2 className="font-heading font-semibold text-lg text-slate-900 mb-4">Recent Orders</h2>
                  {orders.length === 0 ? (
                    <p className="text-slate-500 text-center py-8">No orders yet</p>
                  ) : (
                    <div className="space-y-3">
                      {orders.slice(0, 5).map((order, idx) => (
                        <div key={order.order_id} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                          <div>
                            <p className="font-mono text-xs text-slate-500">{order.order_id}</p>
                            <p className="text-sm text-slate-700">£{order.total_amount?.toFixed(2)}</p>
                          </div>
                          <span className={`text-xs px-2 py-1 rounded-full ${
                            order.status === "paid" ? "bg-emerald-100 text-emerald-700" :
                            order.status === "pending" ? "bg-amber-100 text-amber-700" :
                            "bg-slate-100 text-slate-700"
                          }`}>
                            {order.status}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="bg-white rounded-xl border border-slate-200 p-6">
                  <h2 className="font-heading font-semibold text-lg text-slate-900 mb-4">Recent Transactions</h2>
                  {transactions.length === 0 ? (
                    <p className="text-slate-500 text-center py-8">No transactions yet</p>
                  ) : (
                    <div className="space-y-3">
                      {transactions.slice(0, 5).map((txn, idx) => (
                        <div key={txn.transaction_id} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                          <div>
                            <p className="font-mono text-xs text-slate-500">{txn.transaction_id}</p>
                            <p className="text-sm text-slate-700">£{txn.amount?.toFixed(2)} {txn.currency?.toUpperCase()}</p>
                          </div>
                          <span className={`text-xs px-2 py-1 rounded-full ${
                            txn.payment_status === "paid" ? "bg-emerald-100 text-emerald-700" :
                            txn.status === "initiated" ? "bg-blue-100 text-blue-700" :
                            "bg-slate-100 text-slate-700"
                          }`}>
                            {txn.payment_status || txn.status}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : activeTab === "merchants" ? (
            <AdminMerchantsTab
              merchants={merchants}
              merchantSearch={merchantSearch}
              setMerchantSearch={setMerchantSearch}
              merchantFilter={merchantFilter}
              setMerchantFilter={setMerchantFilter}
              selectedMerchantIds={selectedMerchantIds}
              setSelectedMerchantIds={setSelectedMerchantIds}
              bulkTogglingStores={bulkTogglingStores}
              sendingReminder={sendingReminder}
              pendingMerchants={pendingMerchants}
              pendingPayment={pendingPayment}
              pendingDocuments={pendingDocuments}
              getFilteredMerchants={getFilteredMerchants}
              handleBulkRemoveTestMerchants={handleBulkRemoveTestMerchants}
              handleSeedDemoAccounts={handleSeedDemoAccounts}
              viewMerchantDetail={viewMerchantDetail}
              viewMerchantDocuments={viewMerchantDocuments}
              openMerchantProfileModal={openMerchantProfileModal}
              openSyncConnectModal={openSyncConnectModal}
              openViewAgreementModal={openViewAgreementModal}
              openSignAgreementModal={openSignAgreementModal}
              openAgreementModal={openAgreementModal}
              openFixSubscriptionModal={openFixSubscriptionModal}
              handleSendReminder={handleSendReminder}
              handleResetAgreement={handleResetAgreement}
              handleDeleteMerchant={handleDeleteMerchant}
              handlePermanentDeleteMerchant={handlePermanentDeleteMerchant}
              handleCreateConnect={handleCreateConnect}
              handleToggleFeature={handleToggleFeature}
              handleToggleStoreStatus={handleToggleStoreStatus}
              handleBulkToggleStoreStatus={handleBulkToggleStoreStatus}
              toggleSelectAllMerchants={toggleSelectAllMerchants}
              toggleMerchantSelection={toggleMerchantSelection}
              setSelectedMerchant={setSelectedMerchant}
              setShowMerchantDetail={setShowMerchantDetail}
            />
          ) : activeTab === "subscriptions" ? (
            <AdminSubscriptionsTab
              allSubscriptions={allSubscriptions}
              syncingStripeData={syncingStripeData}
              handleSyncStripeData={handleSyncStripeData}
              setSelectedSubMerchant={setSelectedSubMerchant}
              setSelectedAddonsForAdmin={setSelectedAddonsForAdmin}
              setShowManageAddonsModal={setShowManageAddonsModal}
              handleCancelSubscription={handleCancelSubscription}
            />
          ) : activeTab === "billing" ? (
            /* Billing Management */
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <span className="text-slate-500">{billings.length} billing records</span>
              </div>

              {billings.length === 0 ? (
                <div className="bg-white rounded-xl border border-slate-200 p-12 text-center">
                  <Receipt className="h-12 w-12 text-slate-300 mx-auto mb-4" />
                  <h3 className="font-heading font-semibold text-slate-900 mb-2">No billing records</h3>
                  <p className="text-slate-500">Merchant billing records will appear here.</p>
                </div>
              ) : (
                <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
                  <table className="w-full">
                    <thead className="bg-slate-50">
                      <tr>
                        <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Merchant</th>
                        <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Period</th>
                        <th className="text-right px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Base Fee</th>
                        <th className="text-right px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Transaction Fees</th>
                        <th className="text-right px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Total</th>
                        <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Status</th>
                        <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Actions</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-200">
                      {billings.map((bill, idx) => (
                        <tr key={bill.billing_id} data-testid={`billing-row-${idx}`}>
                          <td className="px-6 py-4">
                            <p className="font-semibold text-slate-900">{bill.merchant_name}</p>
                            <p className="text-xs text-slate-500">{bill.merchant_email}</p>
                          </td>
                          <td className="px-6 py-4 text-sm">
                            {new Date(bill.period_start).toLocaleDateString('en-GB', { month: 'short', year: 'numeric' })}
                          </td>
                          <td className="px-6 py-4 text-right">£{bill.base_plan_amount?.toFixed(2)}</td>
                          <td className="px-6 py-4 text-right">£{bill.transaction_fees?.toFixed(2)}</td>
                          <td className="px-6 py-4 text-right font-semibold">£{bill.total_amount?.toFixed(2)}</td>
                          <td className="px-6 py-4">
                            <span className={`text-xs px-2 py-1 rounded-full ${
                              bill.status === "paid" ? "bg-emerald-100 text-emerald-700" :
                              bill.status === "overdue" ? "bg-red-100 text-red-700" :
                              "bg-amber-100 text-amber-700"
                            }`}>
                              {bill.status}
                            </span>
                          </td>
                          <td className="px-6 py-4">
                            {bill.status !== "paid" && (
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={() => handleUpdateBillingStatus(bill.billing_id, "paid")}
                                className="text-emerald-600 hover:bg-emerald-50"
                              >
                                Mark Paid
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          ) : activeTab === "promo-codes" ? (
            /* Promo Codes Management */
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <p className="text-slate-500">{promoCodes.length} promo codes</p>
                <Button 
                  onClick={() => setShowPromoModal(true)}
                  className="bg-indigo-600 hover:bg-indigo-700"
                  data-testid="create-promo-btn"
                >
                  <Plus className="h-4 w-4 mr-2" />
                  Create Promo Code
                </Button>
              </div>

              <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
                <table className="w-full">
                  <thead className="bg-slate-50">
                    <tr>
                      <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Code</th>
                      <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Type</th>
                      <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Value</th>
                      <th className="text-center px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Uses</th>
                      <th className="text-center px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Status</th>
                      <th className="text-right px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-200">
                    {promoCodes.map((promo, idx) => (
                      <tr key={promo.promo_id || promo.code} data-testid={`promo-row-${idx}`}>
                        <td className="px-6 py-4">
                          <div className="flex items-center gap-2">
                            <Tag className="h-4 w-4 text-indigo-500" />
                            <span className="font-mono font-semibold text-slate-900">{promo.code}</span>
                            {promo.is_default && (
                              <span className="text-xs bg-slate-100 text-slate-600 px-2 py-0.5 rounded">Default</span>
                            )}
                          </div>
                        </td>
                        <td className="px-6 py-4">
                          <span className={`text-xs px-2 py-1 rounded-full ${
                            promo.type === "percentage" ? "bg-blue-100 text-blue-700" :
                            promo.type === "free_onboarding" ? "bg-emerald-100 text-emerald-700" :
                            promo.type === "free_onboarding_trial" ? "bg-gradient-to-r from-emerald-100 to-purple-100 text-purple-700" :
                            "bg-purple-100 text-purple-700"
                          }`}>
                            {promo.type === "percentage" ? "% Discount" :
                             promo.type === "free_onboarding" ? "Free Onboarding" :
                             promo.type === "free_onboarding_trial" ? "Free Onboarding + Trial" :
                             "Free Trial"}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-slate-600">
                          {promo.type === "percentage" ? `${promo.discount_percent}% off` :
                           promo.type === "free_onboarding" ? "Setup waived" :
                           promo.type === "free_onboarding_trial" ? `Setup waived + ${promo.trial_days || 30} days free` :
                           `${promo.trial_days} days free`}
                        </td>
                        <td className="px-6 py-4 text-center text-slate-600">
                          {promo.uses_count || 0} / {promo.max_uses || "∞"}
                        </td>
                        <td className="px-6 py-4 text-center">
                          <span className={`text-xs px-2 py-1 rounded-full ${
                            promo.active ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-600"
                          }`}>
                            {promo.active ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <div className="flex items-center justify-end gap-2">
                            {!promo.is_default && (
                              <>
                                <Button
                                  size="sm"
                                  variant="ghost"
                                  onClick={() => handleTogglePromoCode(promo.promo_id, promo.active)}
                                  className={promo.active ? "text-amber-600" : "text-emerald-600"}
                                >
                                  {promo.active ? "Deactivate" : "Activate"}
                                </Button>
                                <Button
                                  size="sm"
                                  variant="ghost"
                                  onClick={() => handleDeletePromoCode(promo.promo_id)}
                                  className="text-red-600 hover:bg-red-50"
                                >
                                  <Trash2 className="h-4 w-4" />
                                </Button>
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Promo Code Types Info */}
              <div className="grid grid-cols-3 gap-4">
                <div className="bg-blue-50 rounded-xl p-4 border border-blue-100">
                  <div className="flex items-center gap-2 mb-2">
                    <PoundSterling className="h-5 w-5 text-blue-600" />
                    <h4 className="font-semibold text-blue-900">Percentage Discount</h4>
                  </div>
                  <p className="text-sm text-blue-700">Give merchants a reduced commission rate on their first transactions</p>
                </div>
                <div className="bg-emerald-50 rounded-xl p-4 border border-emerald-100">
                  <div className="flex items-center gap-2 mb-2">
                    <Gift className="h-5 w-5 text-emerald-600" />
                    <h4 className="font-semibold text-emerald-900">Free Onboarding</h4>
                  </div>
                  <p className="text-sm text-emerald-700">Waive setup requirements for new merchants</p>
                </div>
                <div className="bg-purple-50 rounded-xl p-4 border border-purple-100">
                  <div className="flex items-center gap-2 mb-2">
                    <Clock className="h-5 w-5 text-purple-600" />
                    <h4 className="font-semibold text-purple-900">Free Trial</h4>
                  </div>
                  <p className="text-sm text-purple-700">Give merchants a free trial period before payment</p>
                </div>
              </div>
              
              {/* Best Value Promo */}
              <div className="bg-gradient-to-r from-emerald-50 to-purple-50 rounded-xl p-4 border border-emerald-200">
                <div className="flex items-center gap-2 mb-2">
                  <Sparkles className="h-5 w-5 text-purple-600" />
                  <h4 className="font-semibold text-purple-900">Free Onboarding + Trial (BEST)</h4>
                  <span className="text-xs bg-purple-100 text-purple-700 px-2 py-0.5 rounded-full">Recommended</span>
                </div>
                <p className="text-sm text-purple-700">
                  Combined offer: Waive setup + give 30 days free trial. Best for attracting new merchants!
                </p>
              </div>
            </div>
          ) : activeTab === "users" ? (
            <AdminUsersTab users={users} openEditUserModal={openEditUserModal} handleSendResetPassword={handleSendResetPassword} handleDeleteUser={handleDeleteUser} />
          ) : activeTab === "commerce" ? (
            <CommerceManagement token={token} />
          ) : activeTab === "pulse-launch" ? (
            <PulseLaunchSubscribers token={token} />
          ) : activeTab === "invoices" ? (
            <AdminInvoicesTab API={API} token={token} adminInvoices={adminInvoices} fetchAllData={fetchAllData} />
          ) : activeTab === "orders" ? (
            <AdminOrdersTab orders={orders} />
          ) : activeTab === "transactions" ? (
            <AdminTransactionsTab transactions={transactions} />
          ) : activeTab === "feedback" ? (
            /* Feedback Tab - Links to dedicated page */
            <div>
              <div className="flex items-center justify-between mb-6">
                <h1 className="font-heading text-2xl font-bold text-slate-900 flex items-center gap-2">
                  <MessageSquare className="h-6 w-6 text-indigo-600" />
                  Customer Feedback
                </h1>
              </div>
              
              <div className="bg-white rounded-xl border border-slate-200 p-8 text-center">
                <MessageSquare className="h-16 w-16 mx-auto text-indigo-600 mb-4" />
                <h2 className="text-xl font-semibold mb-2">Feedback Management</h2>
                <p className="text-slate-500 mb-6">
                  View customer feedback, ratings, and analytics for all merchants.
                </p>
                <Link to="/admin/feedback">
                  <Button className="bg-indigo-600 hover:bg-indigo-700">
                    Open Feedback Dashboard
                    <ChevronRight className="h-4 w-4 ml-2" />
                  </Button>
                </Link>
              </div>
            </div>
          ) : activeTab === "ai-credits" ? (
            /* AI Credits Management */
            <div className="space-y-6">
              <div className="flex justify-between items-center">
                <h1 className="text-xl font-semibold flex items-center gap-3">
                  <Sparkles className="h-6 w-6 text-purple-600" />
                  AI Credits Management
                </h1>
                <Button 
                  onClick={() => setShowAddCreditsModal(true)} 
                  className="bg-purple-600 hover:bg-purple-700"
                  data-testid="add-credits-global-btn"
                >
                  <Plus className="h-4 w-4 mr-2" />
                  Add AI Credits
                </Button>
              </div>
              
              <div className="bg-white rounded-xl border border-slate-200 p-6">
                <h2 className="text-lg font-semibold mb-4">Quick Add Credits</h2>
                <p className="text-slate-500 text-sm mb-4">Select a merchant and add AI credits to their account.</p>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <Label className="text-sm text-slate-500 block mb-2">Select Merchant</Label>
                    <Select 
                      value={selectedMerchantForCredits} 
                      onValueChange={setSelectedMerchantForCredits}
                    >
                      <SelectTrigger data-testid="select-merchant-credits-inline">
                        <SelectValue placeholder="Select merchant..." />
                      </SelectTrigger>
                      <SelectContent>
                        {merchants.filter(m => m.is_approved && !m.is_deleted).map((m) => (
                          <SelectItem key={m.user_id} value={m.user_id}>
                            {m.business_name || m.name} ({m.email})
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label className="text-sm text-slate-500 block mb-2">Credit Amount</Label>
                    <Input
                      type="number"
                      value={creditAmount}
                      onChange={(e) => setCreditAmount(parseInt(e.target.value) || 0)}
                      min={1}
                      data-testid="credit-amount-inline"
                    />
                  </div>
                  <div>
                    <Label className="text-sm text-slate-500 block mb-2">Reason</Label>
                    <Input
                      value={creditReason}
                      onChange={(e) => setCreditReason(e.target.value)}
                      placeholder="e.g., Welcome bonus"
                      data-testid="credit-reason-inline"
                    />
                  </div>
                </div>
                
                <Button 
                  onClick={handleAddAICredits}
                  disabled={!selectedMerchantForCredits || creditAmount <= 0}
                  className="mt-4 bg-purple-600 hover:bg-purple-700"
                  data-testid="add-credits-inline-btn"
                >
                  <Sparkles className="h-4 w-4 mr-2" />
                  Add {creditAmount} Credits
                </Button>
              </div>
              
              <div className="bg-white rounded-xl border border-slate-200 p-6">
                <h2 className="text-lg font-semibold mb-2">Credit Packages</h2>
                <p className="text-slate-500 text-sm mb-4">Standard credit packages for quick allocation.</p>
                
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                  {[
                    { amount: 50, label: "Starter", desc: "10 images" },
                    { amount: 100, label: "Basic", desc: "20 images" },
                    { amount: 500, label: "Pro", desc: "100 images" },
                    { amount: 1000, label: "Enterprise", desc: "200 images" }
                  ].map((pkg) => (
                    <div key={pkg.amount} className="border border-slate-200 rounded-lg p-4 text-center hover:border-purple-300 transition-colors">
                      <p className="text-2xl font-bold text-purple-600">{pkg.amount}</p>
                      <p className="font-medium">{pkg.label}</p>
                      <p className="text-xs text-slate-500">{pkg.desc}</p>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => { setCreditAmount(pkg.amount); }}
                        className="mt-2 text-purple-600 border-purple-200 hover:bg-purple-50"
                      >
                        Select
                      </Button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </main>

      {/* User Detail Modal */}
      <Dialog open={!!selectedUser} onOpenChange={() => setSelectedUser(null)}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="font-heading">User Details</DialogTitle>
          </DialogHeader>
          {selectedUser && (
            <div className="space-y-4 py-4">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center">
                  {selectedUser.picture ? (
                    <img src={selectedUser.picture} alt="" className="w-16 h-16 rounded-full" />
                  ) : (
                    <span className="font-heading text-2xl font-bold text-slate-600">
                      {selectedUser.name?.charAt(0)?.toUpperCase()}
                    </span>
                  )}
                </div>
                <div>
                  <h3 className="font-heading font-semibold text-lg">{selectedUser.name}</h3>
                  <p className="text-slate-500">{selectedUser.email}</p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4 pt-4 border-t">
                <div>
                  <p className="text-sm text-slate-500">Role</p>
                  <p className="font-medium capitalize">{selectedUser.role}</p>
                </div>
                <div>
                  <p className="text-sm text-slate-500">Status</p>
                  <p className="font-medium">{selectedUser.is_approved !== false ? "Active" : "Pending"}</p>
                </div>
                {selectedUser.business_name && (
                  <div className="col-span-2">
                    <p className="text-sm text-slate-500">Business Name</p>
                    <p className="font-medium">{selectedUser.business_name}</p>
                  </div>
                )}
                <div className="col-span-2">
                  <p className="text-sm text-slate-500">User ID</p>
                  <p className="font-mono text-sm">{selectedUser.user_id}</p>
                </div>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Document Review Modal */}
      <Dialog open={showDocumentsModal} onOpenChange={setShowDocumentsModal}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="font-heading flex items-center gap-2">
              <FileText className="h-5 w-5 text-indigo-600" />
              Review Merchant Documents
            </DialogTitle>
            <DialogDescription>
              {selectedMerchant?.business_name || selectedMerchant?.name} - {selectedMerchant?.email}
            </DialogDescription>
          </DialogHeader>
          {selectedMerchant && (
            <div className="space-y-4 py-4">
              {/* Documents Summary */}
              <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                <span className="text-sm text-slate-600">
                  {selectedMerchant.documents?.length || 0} document(s) uploaded
                </span>
                <div className="flex items-center gap-2">
                  {selectedMerchant.documents?.filter(d => d.status === "approved").length > 0 && (
                    <span className="text-xs px-2 py-1 bg-emerald-100 text-emerald-700 rounded-full">
                      {selectedMerchant.documents.filter(d => d.status === "approved").length} Approved
                    </span>
                  )}
                  {selectedMerchant.documents?.filter(d => d.status === "pending").length > 0 && (
                    <span className="text-xs px-2 py-1 bg-amber-100 text-amber-700 rounded-full">
                      {selectedMerchant.documents.filter(d => d.status === "pending").length} Pending
                    </span>
                  )}
                  {selectedMerchant.documents?.filter(d => d.status === "rejected").length > 0 && (
                    <span className="text-xs px-2 py-1 bg-red-100 text-red-700 rounded-full">
                      {selectedMerchant.documents.filter(d => d.status === "rejected").length} Rejected
                    </span>
                  )}
                </div>
              </div>

              {/* Documents List */}
              {!selectedMerchant.documents || selectedMerchant.documents.length === 0 ? (
                <div className="text-center py-12 bg-slate-50 rounded-xl border-2 border-dashed border-slate-200">
                  <FileText className="h-12 w-12 text-slate-300 mx-auto mb-3" />
                  <p className="text-slate-500 font-medium">No documents uploaded yet</p>
                  <p className="text-sm text-slate-400 mt-1">The merchant hasn't uploaded any documents</p>
                </div>
              ) : (
                <div className="space-y-3">
                  {selectedMerchant.documents.map((doc, idx) => (
                    <div 
                      key={doc.document_id || idx} 
                      className={`border rounded-xl p-4 transition-all ${
                        doc.status === "approved" ? "border-emerald-200 bg-emerald-50/30" :
                        doc.status === "rejected" ? "border-red-200 bg-red-50/30" :
                        "border-slate-200 bg-white hover:border-indigo-200"
                      }`}
                      data-testid={`document-item-${idx}`}
                    >
                      <div className="flex items-start justify-between gap-4">
                        <div className="flex items-start gap-3 flex-1">
                          <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${
                            doc.status === "approved" ? "bg-emerald-100" :
                            doc.status === "rejected" ? "bg-red-100" :
                            "bg-indigo-100"
                          }`}>
                            <FileText className={`h-6 w-6 ${
                              doc.status === "approved" ? "text-emerald-600" :
                              doc.status === "rejected" ? "text-red-600" :
                              "text-indigo-600"
                            }`} />
                          </div>
                          <div className="flex-1 min-w-0">
                            <p className="font-semibold text-slate-900 capitalize">
                              {doc.document_type?.replace(/_/g, ' ') || 'Document'}
                            </p>
                            <p className="text-sm text-slate-500 truncate">{doc.file_name || doc.filename || 'No filename'}</p>
                            <div className="flex items-center gap-3 mt-2">
                              {(doc.document_url || doc.file_url) && (
                                <>
                                  <a 
                                    href={doc.document_url || doc.file_url} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-1 text-sm text-indigo-600 hover:text-indigo-800 font-medium"
                                  >
                                    <Eye className="h-4 w-4" />
                                    Preview
                                  </a>
                                  <a 
                                    href={doc.document_url || doc.file_url} 
                                    download={doc.file_name || doc.filename}
                                    className="inline-flex items-center gap-1 text-sm text-slate-600 hover:text-slate-800"
                                  >
                                    <Download className="h-4 w-4" />
                                    Download
                                  </a>
                                </>
                              )}
                            </div>
                            {doc.review_notes && (
                              <p className="text-xs text-slate-500 mt-2 italic">
                                Review note: {doc.review_notes}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="flex flex-col items-end gap-2">
                          <span className={`text-xs px-3 py-1 rounded-full font-medium ${
                            doc.status === "approved" ? "bg-emerald-100 text-emerald-700" :
                            doc.status === "rejected" ? "bg-red-100 text-red-700" :
                            "bg-amber-100 text-amber-700"
                          }`}>
                            {doc.status === "approved" ? "Approved" : 
                             doc.status === "rejected" ? "Rejected" : "Pending Review"}
                          </span>
                          {doc.status === "pending" && (
                            <div className="flex gap-2">
                              <Button
                                size="sm"
                                onClick={() => handleReviewDocument(doc.document_id, "approved")}
                                className="bg-emerald-600 hover:bg-emerald-700 rounded-full"
                              >
                                <Check className="h-4 w-4 mr-1" />
                                Approve
                              </Button>
                              <Button
                                size="sm"
                                variant="outline"
                                onClick={() => handleReviewDocument(doc.document_id, "rejected", "Document requires revision")}
                                className="border-red-200 text-red-600 hover:bg-red-50 rounded-full"
                              >
                                <X className="h-4 w-4 mr-1" />
                                Reject
                              </Button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Actions */}
              <div className="flex gap-3 pt-4 border-t">
                <Button
                  onClick={() => handleApproveMerchant(selectedMerchant.user_id)}
                  className="flex-1 bg-emerald-600 hover:bg-emerald-700 rounded-full"
                  disabled={!selectedMerchant.documents?.length || !selectedMerchant.documents?.every(d => d.status === "approved")}
                  data-testid="approve-merchant-btn"
                >
                  <CheckCircle className="h-4 w-4 mr-2" />
                  Approve Merchant
                </Button>
                <Button
                  onClick={() => openRejectModal(selectedMerchant)}
                  variant="outline"
                  className="flex-1 border-red-200 text-red-600 hover:bg-red-50 rounded-full"
                  data-testid="reject-merchant-btn"
                >
                  <XCircle className="h-4 w-4 mr-2" />
                  Reject Application
                </Button>
              </div>
              {/* Helper message */}
              {selectedMerchant.documents?.length > 0 && !selectedMerchant.documents?.every(d => d.status === "approved") && (
                <p className="text-sm text-amber-600 text-center bg-amber-50 p-3 rounded-lg">
                  <AlertCircle className="h-4 w-4 inline mr-1" />
                  All documents must be approved before approving the merchant.
                </p>
              )}
              {!selectedMerchant.documents?.length && (
                <p className="text-sm text-slate-500 text-center">
                  Merchant needs to upload documents before they can be approved.
                </p>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Reject Merchant Modal */}
      <Dialog open={showRejectModal} onOpenChange={setShowRejectModal}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="font-heading">Reject Merchant Application</DialogTitle>
            <DialogDescription>
              This will reject {selectedMerchant?.business_name || selectedMerchant?.name}'s application.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label>Rejection Reason</Label>
              <Textarea
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                placeholder="Provide a reason for rejection..."
                rows={4}
              />
            </div>
            <div className="flex gap-3">
              <Button
                onClick={() => setShowRejectModal(false)}
                variant="outline"
                className="flex-1 rounded-full"
              >
                Cancel
              </Button>
              <Button
                onClick={handleRejectMerchant}
                className="flex-1 bg-red-600 hover:bg-red-700 rounded-full"
              >
                Reject Application
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Create Promo Code Modal */}
      <Dialog open={showPromoModal} onOpenChange={setShowPromoModal}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="font-heading">Create New Promo Code</DialogTitle>
          </DialogHeader>
          <form onSubmit={handleCreatePromoCode} className="space-y-4 py-4">
            <div className="space-y-2">
              <Label>Promo Code *</Label>
              <Input
                value={promoForm.code}
                onChange={(e) => setPromoForm({ ...promoForm, code: e.target.value.toUpperCase() })}
                placeholder="e.g., WELCOME20"
                required
                className="font-mono uppercase"
              />
            </div>

            <div className="space-y-2">
              <Label>Promo Type *</Label>
              <Select
                value={promoForm.type}
                onValueChange={(value) => setPromoForm({ ...promoForm, type: value })}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="percentage">Percentage Discount</SelectItem>
                  <SelectItem value="free_onboarding">Free Onboarding</SelectItem>
                  <SelectItem value="free_trial">Free Trial Period</SelectItem>
                  <SelectItem value="free_onboarding_trial">Free Onboarding + Trial (BEST)</SelectItem>
                </SelectContent>
              </Select>
            </div>

            {promoForm.type === "percentage" && (
              <div className="space-y-2">
                <Label>Discount Percentage *</Label>
                <Input
                  type="number"
                  min="1"
                  max="100"
                  value={promoForm.discount_percent}
                  onChange={(e) => setPromoForm({ ...promoForm, discount_percent: parseInt(e.target.value) || 0 })}
                  required
                />
              </div>
            )}

            {(promoForm.type === "free_trial" || promoForm.type === "free_onboarding_trial") && (
              <div className="space-y-2">
                <Label>Trial Days *</Label>
                <Input
                  type="number"
                  min="1"
                  max="365"
                  value={promoForm.trial_days}
                  onChange={(e) => setPromoForm({ ...promoForm, trial_days: parseInt(e.target.value) || 30 })}
                  required
                />
                {promoForm.type === "free_onboarding_trial" && (
                  <p className="text-xs text-emerald-600">This gives FREE onboarding + extended trial period!</p>
                )}
              </div>
            )}

            <div className="space-y-2">
              <Label>Max Uses (leave empty for unlimited)</Label>
              <Input
                type="number"
                min="1"
                value={promoForm.max_uses}
                onChange={(e) => setPromoForm({ ...promoForm, max_uses: e.target.value })}
                placeholder="Unlimited"
              />
            </div>

            <div className="space-y-2">
              <Label>Expiry Date (optional)</Label>
              <Input
                type="date"
                value={promoForm.expires_at}
                onChange={(e) => setPromoForm({ ...promoForm, expires_at: e.target.value })}
              />
            </div>

            <div className="flex gap-3 pt-4">
              <Button
                type="button"
                onClick={() => setShowPromoModal(false)}
                variant="outline"
                className="flex-1 rounded-full"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="flex-1 bg-indigo-600 hover:bg-indigo-700 rounded-full"
              >
                Create Promo Code
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      {/* Initiate Merchant Agreement Modal */}
      <Dialog open={showAgreementModal} onOpenChange={setShowAgreementModal}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="font-heading">Initiate Platform Agreement</DialogTitle>
            <DialogDescription>
              Create and send the platform agreement to {selectedMerchant?.business_name || selectedMerchant?.name} for signing.
            </DialogDescription>
          </DialogHeader>
          
          {merchantAgreement && merchantAgreement.status !== "rejected" ? (
            <div className="space-y-4">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <p className="text-sm text-blue-700">
                  <AlertCircle className="h-4 w-4 inline mr-2" />
                  Agreement already exists for this merchant.
                </p>
                <p className="text-xs text-blue-600 mt-2">Status: {merchantAgreement.status}</p>
              </div>
              <div className="flex justify-end">
                <Button variant="outline" onClick={() => setShowAgreementModal(false)}>Close</Button>
              </div>
            </div>
          ) : (
            <form onSubmit={handleInitiateAgreement} className="space-y-4">
              <div className="space-y-2">
                <Label>Agreement Content *</Label>
                <Textarea
                  value={agreementForm.agreement_content}
                  onChange={(e) => setAgreementForm({...agreementForm, agreement_content: e.target.value})}
                  placeholder="Enter the main agreement content..."
                  rows={4}
                  required
                />
              </div>
              
              <div className="space-y-2">
                <Label>Terms & Conditions *</Label>
                <Textarea
                  value={agreementForm.terms_and_conditions}
                  onChange={(e) => setAgreementForm({...agreementForm, terms_and_conditions: e.target.value})}
                  placeholder="Enter terms and conditions..."
                  rows={4}
                  required
                />
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label>Platform Commission (%)</Label>
                  <Input
                    type="number"
                    step="0.1"
                    min="0"
                    max="100"
                    value={agreementForm.commission_rate}
                    onChange={(e) => setAgreementForm({...agreementForm, commission_rate: parseFloat(e.target.value)})}
                  />
                </div>
                <div className="space-y-2">
                  <Label>Transaction Fee (%)</Label>
                  <Input
                    type="number"
                    step="0.1"
                    min="0"
                    max="100"
                    value={agreementForm.transaction_fee}
                    onChange={(e) => setAgreementForm({...agreementForm, transaction_fee: parseFloat(e.target.value)})}
                  />
                </div>
              </div>
              
              <div className="space-y-2">
                <Label>Payment Terms</Label>
                <Textarea
                  value={agreementForm.payment_terms}
                  onChange={(e) => setAgreementForm({...agreementForm, payment_terms: e.target.value})}
                  placeholder="Describe payout terms..."
                  rows={2}
                />
              </div>
              
              <div className="space-y-2">
                <Label>Effective Date</Label>
                <Input
                  type="date"
                  value={agreementForm.effective_date}
                  onChange={(e) => setAgreementForm({...agreementForm, effective_date: e.target.value})}
                />
              </div>
              
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm text-amber-700">
                <AlertCircle className="h-4 w-4 inline mr-2" />
                The merchant will receive an email with a link to review and sign this agreement.
              </div>
              
              <div className="flex gap-3">
                <Button type="button" variant="outline" onClick={() => setShowAgreementModal(false)} className="flex-1 rounded-full">
                  Cancel
                </Button>
                <Button type="submit" className="flex-1 bg-purple-600 hover:bg-purple-700 rounded-full">
                  <Send className="h-4 w-4 mr-2" />
                  Send Agreement
                </Button>
              </div>
            </form>
          )}
        </DialogContent>
      </Dialog>

      {/* Admin Sign Agreement Modal */}
      <Dialog open={showSignAgreementModal} onOpenChange={setShowSignAgreementModal}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="font-heading">Sign Platform Agreement</DialogTitle>
            <DialogDescription>
              Counter-sign the agreement for {selectedMerchant?.business_name || selectedMerchant?.name}.
            </DialogDescription>
          </DialogHeader>
          
          {merchantAgreement && (
            <div className="space-y-4">
              <div className="bg-slate-50 rounded-lg p-4 space-y-2">
                <p className="text-sm"><strong>Status:</strong> {merchantAgreement.status}</p>
                <p className="text-sm"><strong>Commission:</strong> {merchantAgreement.commission_rate}%</p>
                <p className="text-sm"><strong>Transaction Fee:</strong> {merchantAgreement.transaction_fee}%</p>
                {merchantAgreement.merchant_signed_at && (
                  <p className="text-sm text-emerald-600">
                    <CheckCircle className="h-3 w-3 inline mr-1" />
                    Merchant signed on: {new Date(merchantAgreement.merchant_signed_at).toLocaleDateString()}
                  </p>
                )}
              </div>
              
              <div className="space-y-2">
                <Label>Your Signature (Type your name) *</Label>
                <Input
                  value={adminSignature}
                  onChange={(e) => setAdminSignature(e.target.value)}
                  placeholder="Type your full name as signature"
                  required
                />
                <p className="text-xs text-slate-500">By signing, you confirm this agreement on behalf of VEYRONIX.</p>
              </div>
              
              <div className="flex gap-3">
                <Button type="button" variant="outline" onClick={() => setShowSignAgreementModal(false)} className="flex-1 rounded-full">
                  Cancel
                </Button>
                <Button 
                  onClick={handleAdminSignAgreement} 
                  className="flex-1 bg-emerald-600 hover:bg-emerald-700 rounded-full"
                  disabled={!adminSignature}
                >
                  <CheckCircle className="h-4 w-4 mr-2" />
                  Sign Agreement
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* View/Edit Agreement Modal */}
      <Dialog open={showViewAgreementModal} onOpenChange={setShowViewAgreementModal}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="font-heading flex items-center justify-between">
              <span>Platform Agreement - {selectedMerchant?.business_name || selectedMerchant?.name}</span>
              {merchantAgreement?.status === "pending_merchant" && !isEditingAgreement && (
                <Button 
                  variant="outline" 
                  size="sm" 
                  onClick={() => setIsEditingAgreement(true)}
                  className="ml-4"
                >
                  <Edit className="h-4 w-4 mr-2" />
                  Edit
                </Button>
              )}
            </DialogTitle>
            <DialogDescription>
              {isEditingAgreement 
                ? "Edit the agreement details below. Changes can only be made before merchant signs."
                : "View the agreement sent to this merchant."}
            </DialogDescription>
          </DialogHeader>
          
          {merchantAgreement && (
            <div className="space-y-6">
              {/* Status Banner */}
              <div className={`rounded-lg p-4 ${
                merchantAgreement.status === "pending_merchant" 
                  ? "bg-amber-50 border border-amber-200"
                  : merchantAgreement.status === "pending_admin"
                  ? "bg-blue-50 border border-blue-200"
                  : merchantAgreement.status === "completed"
                  ? "bg-emerald-50 border border-emerald-200"
                  : "bg-gray-50 border border-gray-200"
              }`}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    {merchantAgreement.status === "pending_merchant" && <Clock className="h-5 w-5 text-amber-600" />}
                    {merchantAgreement.status === "pending_admin" && <FileText className="h-5 w-5 text-blue-600" />}
                    {merchantAgreement.status === "completed" && <CheckCircle className="h-5 w-5 text-emerald-600" />}
                    <span className="font-medium">
                      {merchantAgreement.status === "pending_merchant" && "Awaiting Merchant Signature"}
                      {merchantAgreement.status === "pending_admin" && "Awaiting Admin Counter-Signature"}
                      {merchantAgreement.status === "completed" && "Agreement Completed"}
                      {merchantAgreement.status === "rejected" && "Agreement Rejected"}
                    </span>
                  </div>
                  <span className="text-xs text-slate-500">
                    Created: {new Date(merchantAgreement.created_at).toLocaleDateString()}
                  </span>
                </div>
              </div>

              {isEditingAgreement ? (
                /* Edit Mode */
                <div className="space-y-4">
                  <div className="space-y-2">
                    <Label>Agreement Content</Label>
                    <Textarea
                      value={agreementForm.agreement_content}
                      onChange={(e) => setAgreementForm({...agreementForm, agreement_content: e.target.value})}
                      rows={4}
                    />
                  </div>
                  
                  <div className="space-y-2">
                    <Label>Terms & Conditions</Label>
                    <Textarea
                      value={agreementForm.terms_and_conditions}
                      onChange={(e) => setAgreementForm({...agreementForm, terms_and_conditions: e.target.value})}
                      rows={4}
                    />
                  </div>
                  
                  <div className="grid grid-cols-2 gap-4">
                    <div className="space-y-2">
                      <Label>Platform Commission (%)</Label>
                      <Input
                        type="number"
                        step="0.1"
                        min="0"
                        max="100"
                        value={agreementForm.commission_rate}
                        onChange={(e) => setAgreementForm({...agreementForm, commission_rate: parseFloat(e.target.value)})}
                      />
                    </div>
                    <div className="space-y-2">
                      <Label>Transaction Fee (%)</Label>
                      <Input
                        type="number"
                        step="0.1"
                        min="0"
                        max="100"
                        value={agreementForm.transaction_fee}
                        onChange={(e) => setAgreementForm({...agreementForm, transaction_fee: parseFloat(e.target.value)})}
                      />
                    </div>
                  </div>
                  
                  <div className="space-y-2">
                    <Label>Payment Terms</Label>
                    <Textarea
                      value={agreementForm.payment_terms}
                      onChange={(e) => setAgreementForm({...agreementForm, payment_terms: e.target.value})}
                      rows={2}
                    />
                  </div>
                  
                  <div className="space-y-2">
                    <Label>Effective Date</Label>
                    <Input
                      type="date"
                      value={agreementForm.effective_date}
                      onChange={(e) => setAgreementForm({...agreementForm, effective_date: e.target.value})}
                    />
                  </div>
                  
                  <div className="flex gap-3 pt-4">
                    <Button 
                      type="button" 
                      variant="outline" 
                      onClick={() => setIsEditingAgreement(false)} 
                      className="flex-1 rounded-full"
                    >
                      Cancel
                    </Button>
                    <Button 
                      onClick={handleUpdateAgreement}
                      className="flex-1 bg-indigo-600 hover:bg-indigo-700 rounded-full"
                    >
                      <Save className="h-4 w-4 mr-2" />
                      Save Changes
                    </Button>
                  </div>
                </div>
              ) : (
                /* View Mode */
                <div className="space-y-6">
                  {/* Agreement Content */}
                  <div className="space-y-2">
                    <Label className="text-slate-500 text-xs uppercase tracking-wide">Agreement Content</Label>
                    <div className="bg-slate-50 rounded-lg p-4 text-sm whitespace-pre-wrap">
                      {merchantAgreement.agreement_content || "No content specified"}
                    </div>
                  </div>
                  
                  {/* Terms & Conditions */}
                  <div className="space-y-2">
                    <Label className="text-slate-500 text-xs uppercase tracking-wide">Terms & Conditions</Label>
                    <div className="bg-slate-50 rounded-lg p-4 text-sm whitespace-pre-wrap">
                      {merchantAgreement.terms_and_conditions || "No terms specified"}
                    </div>
                  </div>
                  
                  {/* Financial Terms */}
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div className="bg-slate-50 rounded-lg p-4 text-center">
                      <p className="text-2xl font-bold text-indigo-600">{merchantAgreement.commission_rate}%</p>
                      <p className="text-xs text-slate-500">Platform Commission</p>
                    </div>
                    <div className="bg-slate-50 rounded-lg p-4 text-center">
                      <p className="text-2xl font-bold text-cyan-600">{merchantAgreement.transaction_fee}%</p>
                      <p className="text-xs text-slate-500">Transaction Fee</p>
                    </div>
                    <div className="bg-slate-50 rounded-lg p-4 text-center col-span-2">
                      <p className="text-sm font-medium text-slate-700">
                        {merchantAgreement.effective_date 
                          ? new Date(merchantAgreement.effective_date).toLocaleDateString()
                          : "Not set"}
                      </p>
                      <p className="text-xs text-slate-500">Effective Date</p>
                    </div>
                  </div>
                  
                  {/* Payment Terms */}
                  {merchantAgreement.payment_terms && (
                    <div className="space-y-2">
                      <Label className="text-slate-500 text-xs uppercase tracking-wide">Payment Terms</Label>
                      <div className="bg-slate-50 rounded-lg p-4 text-sm">
                        {merchantAgreement.payment_terms}
                      </div>
                    </div>
                  )}
                  
                  {/* Signature Status */}
                  <div className="border-t pt-4 space-y-3">
                    <Label className="text-slate-500 text-xs uppercase tracking-wide">Signatures</Label>
                    <div className="grid grid-cols-2 gap-4">
                      <div className={`rounded-lg p-4 border ${merchantAgreement.merchant_signature ? 'border-emerald-200 bg-emerald-50' : 'border-gray-200 bg-gray-50'}`}>
                        <p className="text-xs text-slate-500 mb-1">Merchant</p>
                        {merchantAgreement.merchant_signature ? (
                          <>
                            <p className="font-medium text-emerald-700 truncate">{merchantAgreement.merchant_signature.substring(0, 50)}</p>
                            <p className="text-xs text-slate-400 mt-1">
                              Signed: {new Date(merchantAgreement.merchant_signed_at).toLocaleDateString()}
                            </p>
                          </>
                        ) : (
                          <p className="text-sm text-slate-400">Not yet signed</p>
                        )}
                      </div>
                      <div className={`rounded-lg p-4 border ${merchantAgreement.admin_signature ? 'border-emerald-200 bg-emerald-50' : 'border-gray-200 bg-gray-50'}`}>
                        <p className="text-xs text-slate-500 mb-1">Admin (VEYRONIX)</p>
                        {merchantAgreement.admin_signature ? (
                          <>
                            <p className="font-medium text-emerald-700">{merchantAgreement.admin_signature}</p>
                            <p className="text-xs text-slate-400 mt-1">
                              Signed: {new Date(merchantAgreement.admin_signed_at).toLocaleDateString()}
                            </p>
                          </>
                        ) : (
                          <p className="text-sm text-slate-400">Pending</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              
              {/* Resend Info - only show if there were resends */}
              {merchantAgreement?.resend_count > 0 && (
                <div className="bg-amber-50 rounded-lg p-3 border border-amber-200">
                  <div className="flex items-center gap-2 text-amber-700">
                    <Bell className="h-4 w-4" />
                    <span className="text-sm">
                      Agreement email resent {merchantAgreement.resend_count} time{merchantAgreement.resend_count > 1 ? 's' : ''}
                      {merchantAgreement.last_resent_at && (
                        <span className="text-amber-600 ml-1">
                          (last: {new Date(merchantAgreement.last_resent_at).toLocaleDateString()})
                        </span>
                      )}
                    </span>
                  </div>
                </div>
              )}
              
              <div className="flex justify-between items-center pt-4 border-t">
                {merchantAgreement?.status === "pending_merchant" && (
                  <Button 
                    variant="outline" 
                    onClick={async () => {
                      try {
                        const response = await fetch(`${API}/admin/merchants/${selectedMerchant.user_id}/agreement/resend`, {
                          method: "POST",
                          headers: { Authorization: `Bearer ${token}` },
                          credentials: "include"
                        });
                        if (response.ok) {
                          const data = await response.json();
                          toast.success(data.message || "Agreement email resent to merchant!");
                          // Refresh agreement data to show updated resend count
                          const agreementRes = await fetch(`${API}/admin/merchants/${selectedMerchant.user_id}/agreement`, {
                            headers: { Authorization: `Bearer ${token}` },
                            credentials: "include"
                          });
                          if (agreementRes.ok) {
                            const agreementData = await agreementRes.json();
                            setMerchantAgreement(agreementData.agreement);
                          }
                        } else {
                          const error = await response.json();
                          toast.error(error.detail || "Failed to resend email");
                        }
                      } catch (error) {
                        toast.error("Failed to resend email");
                      }
                    }}
                    className="rounded-full"
                    data-testid="resend-agreement-btn"
                  >
                    <Send className="h-4 w-4 mr-2" />
                    Resend Email
                    {merchantAgreement?.resend_count > 0 && (
                      <span className="ml-2 text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">
                        #{merchantAgreement.resend_count + 1}
                      </span>
                    )}
                  </Button>
                )}
                <Button variant="outline" onClick={() => setShowViewAgreementModal(false)} className="rounded-full ml-auto">
                  Close
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Merchant Profile Modal */}
      <Dialog open={showMerchantProfileModal} onOpenChange={setShowMerchantProfileModal}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="font-heading flex items-center gap-2">
              <User className="h-5 w-5 text-indigo-600" />
              Business Details - {selectedMerchant?.business_name || selectedMerchant?.name}
            </DialogTitle>
            <DialogDescription>
              Merchant profile information submitted during registration
            </DialogDescription>
          </DialogHeader>
          
          {merchantProfileData ? (
            <div className="space-y-6">
              {merchantProfileData.profile ? (
                <>
                  {/* Contact Information */}
                  <div className="bg-slate-50 rounded-xl p-5">
                    <h4 className="font-medium text-slate-900 mb-4 flex items-center gap-2">
                      <User className="h-4 w-4 text-indigo-500" />
                      Contact Information
                    </h4>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-xs text-slate-500 uppercase tracking-wide">Contact Name</p>
                        <p className="font-medium text-slate-900">{merchantProfileData.profile.contact_name || "Not provided"}</p>
                      </div>
                      <div>
                        <p className="text-xs text-slate-500 uppercase tracking-wide">Company Name</p>
                        <p className="font-medium text-slate-900">{merchantProfileData.profile.company_name || "Not provided"}</p>
                      </div>
                      <div>
                        <p className="text-xs text-slate-500 uppercase tracking-wide">Phone Number</p>
                        <p className="font-medium text-slate-900">{merchantProfileData.profile.phone_number || "Not provided"}</p>
                      </div>
                      <div>
                        <p className="text-xs text-slate-500 uppercase tracking-wide">Email</p>
                        <p className="font-medium text-slate-900">{merchantProfileData.profile.email || merchantProfileData.user?.email || "Not provided"}</p>
                      </div>
                    </div>
                  </div>
                  
                  {/* Business Information */}
                  <div className="bg-slate-50 rounded-xl p-5">
                    <h4 className="font-medium text-slate-900 mb-4 flex items-center gap-2">
                      <Store className="h-4 w-4 text-cyan-500" />
                      Business Information
                    </h4>
                    <div className="grid grid-cols-2 gap-4 mb-4">
                      <div>
                        <p className="text-xs text-slate-500 uppercase tracking-wide">Business Type</p>
                        <p className="font-medium text-slate-900">{merchantProfileData.profile.business_type || "Not specified"}</p>
                      </div>
                      <div>
                        <p className="text-xs text-slate-500 uppercase tracking-wide">Business Address</p>
                        <p className="font-medium text-slate-900">{merchantProfileData.profile.business_address || "Not provided"}</p>
                      </div>
                    </div>
                    {merchantProfileData.profile.business_brief && (
                      <div>
                        <p className="text-xs text-slate-500 uppercase tracking-wide mb-2">Business Brief</p>
                        <p className="text-sm text-slate-700 bg-white rounded-lg p-3 border border-slate-200">
                          {merchantProfileData.profile.business_brief}
                        </p>
                      </div>
                    )}
                  </div>
                  
                  {/* Account Info */}
                  <div className="bg-slate-50 rounded-xl p-5">
                    <h4 className="font-medium text-slate-900 mb-4 flex items-center gap-2">
                      <FileText className="h-4 w-4 text-purple-500" />
                      Account Information
                    </h4>
                    <div className="grid grid-cols-3 gap-4">
                      <div>
                        <p className="text-xs text-slate-500 uppercase tracking-wide">Status</p>
                        <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                          merchantProfileData.user?.is_approved 
                            ? "bg-emerald-100 text-emerald-700" 
                            : "bg-amber-100 text-amber-700"
                        }`}>
                          {merchantProfileData.user?.is_approved ? "Approved" : merchantProfileData.user?.merchant_status || "Pending"}
                        </span>
                      </div>
                      <div>
                        <p className="text-xs text-slate-500 uppercase tracking-wide">Registered</p>
                        <p className="font-medium text-slate-900">
                          {merchantProfileData.user?.created_at 
                            ? new Date(merchantProfileData.user.created_at).toLocaleDateString() 
                            : "N/A"}
                        </p>
                      </div>
                      <div>
                        <p className="text-xs text-slate-500 uppercase tracking-wide">Profile Updated</p>
                        <p className="font-medium text-slate-900">
                          {merchantProfileData.profile.updated_at 
                            ? new Date(merchantProfileData.profile.updated_at).toLocaleDateString() 
                            : "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
              
              {/* Store Settings Section - Always show if store_settings exists */}
              {merchantProfileData.store_settings && (
                <div className="bg-slate-50 rounded-xl p-5">
                  <h4 className="font-medium text-slate-900 mb-4 flex items-center gap-2">
                    <Building2 className="h-4 w-4 text-indigo-500" />
                    Store Settings (Updated by Merchant)
                  </h4>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <p className="text-xs text-slate-500 uppercase tracking-wide">Store Name</p>
                      <p className="font-medium text-slate-900">{merchantProfileData.store_settings.business_name || "Not set"}</p>
                    </div>
                    <div>
                      <p className="text-xs text-slate-500 uppercase tracking-wide">Contact Email</p>
                      <p className="font-medium text-slate-900">{merchantProfileData.store_settings.contact_email || "Not set"}</p>
                    </div>
                    <div>
                      <p className="text-xs text-slate-500 uppercase tracking-wide">Contact Phone</p>
                      <p className="font-medium text-slate-900">{merchantProfileData.store_settings.contact_phone || "Not set"}</p>
                    </div>
                    <div>
                      <p className="text-xs text-slate-500 uppercase tracking-wide">Website</p>
                      <p className="font-medium text-slate-900">{merchantProfileData.store_settings.website || "Not set"}</p>
                    </div>
                    <div>
                      <p className="text-xs text-slate-500 uppercase tracking-wide">Address</p>
                      <p className="font-medium text-slate-900">
                        {merchantProfileData.store_settings.address || "Not set"}
                        {merchantProfileData.store_settings.city && `, ${merchantProfileData.store_settings.city}`}
                        {merchantProfileData.store_settings.postcode && ` ${merchantProfileData.store_settings.postcode}`}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-slate-500 uppercase tracking-wide">Opening Hours</p>
                      <p className="font-medium text-slate-900">{merchantProfileData.store_settings.opening_hours || "Not set"}</p>
                    </div>
                    {merchantProfileData.store_settings.store_description && (
                      <div className="col-span-2">
                        <p className="text-xs text-slate-500 uppercase tracking-wide mb-2">Store Description</p>
                        <p className="text-sm text-slate-700 bg-white rounded-lg p-3 border border-slate-200">
                          {merchantProfileData.store_settings.store_description}
                        </p>
                      </div>
                    )}
                    <div className="col-span-2">
                      <p className="text-xs text-slate-500 uppercase tracking-wide">Last Updated</p>
                      <p className="text-sm text-slate-600">
                        {merchantProfileData.store_settings.updated_at 
                          ? new Date(merchantProfileData.store_settings.updated_at).toLocaleString() 
                          : "N/A"}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              
              {/* Show message if neither profile nor store settings exist */}
              {!merchantProfileData.profile && !merchantProfileData.store_settings && (
                <div className="text-center py-8">
                  <AlertCircle className="h-12 w-12 text-slate-300 mx-auto mb-4" />
                  <p className="text-slate-500">No profile information submitted yet.</p>
                  <p className="text-sm text-slate-400 mt-1">The merchant hasn't filled in their business details.</p>
                </div>
              )}
              
              <div className="flex justify-end pt-4 border-t">
                <Button variant="outline" onClick={() => setShowMerchantProfileModal(false)} className="rounded-full">
                  Close
                </Button>
              </div>
            </div>
          ) : (
            <div className="text-center py-8">
              <RefreshCw className="h-8 w-8 text-slate-300 mx-auto mb-4 animate-spin" />
              <p className="text-slate-500">Loading profile...</p>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Merchant Detail Modal */}
      <Dialog open={showMerchantDetail} onOpenChange={setShowMerchantDetail}>
        <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Merchant Details</DialogTitle>
          </DialogHeader>
          {merchantDetailData && (
            <div className="space-y-6">
              {/* Basic Info */}
              <div className="grid grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div>
                    <Label className="text-slate-500 text-xs">Business Name</Label>
                    <p className="font-semibold">{merchantDetailData.business_name || "N/A"}</p>
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Contact Name</Label>
                    <p>{merchantDetailData.name}</p>
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Email</Label>
                    <p>{merchantDetailData.email}</p>
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Phone</Label>
                    <p>{merchantDetailData.phone || "N/A"}</p>
                  </div>
                </div>
                <div className="space-y-4">
                  <div>
                    <Label className="text-slate-500 text-xs">Status</Label>
                    <p className="capitalize">{merchantDetailData.merchant_status || "Unknown"}</p>
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Commission</Label>
                    <p>5% per transaction</p>
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">POS Access</Label>
                    <p>{merchantDetailData.pos_enabled ? "Enabled" : "Disabled"}</p>
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Joined</Label>
                    <p>{merchantDetailData.created_at ? new Date(merchantDetailData.created_at).toLocaleDateString() : "N/A"}</p>
                  </div>
                </div>
              </div>

              {/* Contact Actions */}
              <div className="flex gap-3">
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => handleContactMerchant(merchantDetailData, "email")}
                >
                  <Send className="h-4 w-4 mr-1" />
                  Email Merchant
                </Button>
                {merchantDetailData.phone && (
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => handleContactMerchant(merchantDetailData, "phone")}
                  >
                    Call Merchant
                  </Button>
                )}
              </div>

              {/* Uploaded Documents */}
              <div className="border-t pt-4">
                <h4 className="font-semibold mb-3">Uploaded Documents</h4>
                {merchantDocuments.length === 0 ? (
                  <p className="text-sm text-slate-500 bg-slate-50 p-4 rounded-lg text-center">No documents uploaded yet</p>
                ) : (
                  <div className="space-y-2 max-h-48 overflow-y-auto">
                    {merchantDocuments.map((doc, idx) => (
                      <div key={doc.document_id || idx} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 rounded bg-indigo-100 flex items-center justify-center">
                            <FileText className="h-4 w-4 text-indigo-600" />
                          </div>
                          <div>
                            <p className="text-sm font-medium capitalize">{(doc.document_type || doc.type || "Document").replace(/_/g, " ")}</p>
                            <p className="text-xs text-slate-500">{doc.file_name || doc.filename || "File"} {doc.uploaded_at ? `- ${new Date(doc.uploaded_at).toLocaleDateString()}` : ""}</p>
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className={`px-2 py-1 rounded text-xs ${doc.status === "approved" ? "bg-emerald-100 text-emerald-700" : doc.status === "rejected" ? "bg-red-100 text-red-700" : "bg-amber-100 text-amber-700"}`}>
                            {doc.status || "pending"}
                          </span>
                          {doc.file_url && (
                            <a href={doc.file_url} target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-800">
                              <Eye className="h-4 w-4" />
                            </a>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* POS Access */}
              <div className="border-t pt-4">
                <h4 className="font-semibold mb-3">Access Management</h4>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => handleTogglePosAccess(merchantDetailData.user_id, !merchantDetailData.pos_enabled)}
                >
                  {merchantDetailData.pos_enabled ? "Disable" : "Enable"} POS Access
                </Button>
              </div>

              {/* Recent Transactions */}
              {merchantTransactions.length > 0 && (
                <div className="border-t pt-4">
                  <h4 className="font-semibold mb-3">Recent POS Transactions ({merchantTransactions.length})</h4>
                  <div className="max-h-48 overflow-y-auto space-y-2">
                    {merchantTransactions.slice(0, 10).map((txn) => (
                      <div key={txn.transaction_id} className="flex justify-between items-center p-3 bg-slate-50 rounded-lg text-sm">
                        <div>
                          <span className="font-mono text-xs text-slate-500">{txn.transaction_number || txn.transaction_id}</span>
                          <p className="text-slate-700">£{(txn.totals?.total || 0) / 100}</p>
                        </div>
                        <span className={`px-2 py-1 rounded text-xs ${txn.status === "completed" ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-600"}`}>
                          {txn.status}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Danger Zone */}
              <div className="border-t pt-4">
                <h4 className="font-semibold mb-3 text-red-600">Danger Zone</h4>
                <Button
                  size="sm"
                  variant="outline"
                  className="text-red-600 border-red-200 hover:bg-red-50"
                  onClick={() => handleRemoveMerchant(merchantDetailData.user_id)}
                >
                  <Trash2 className="h-4 w-4 mr-1" />
                  Remove Merchant
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Edit Merchant Modal */}
      <Dialog open={showEditMerchant} onOpenChange={setShowEditMerchant}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Edit Merchant</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div>
              <label className="text-sm text-slate-500 block mb-1">First Name</label>
              <Input
                value={editMerchantForm.first_name || ""}
                onChange={(e) => setEditMerchantForm({...editMerchantForm, first_name: e.target.value})}
              />
            </div>
            <div>
              <label className="text-sm text-slate-500 block mb-1">Last Name</label>
              <Input
                value={editMerchantForm.last_name || ""}
                onChange={(e) => setEditMerchantForm({...editMerchantForm, last_name: e.target.value})}
              />
            </div>
            <div>
              <label className="text-sm text-slate-500 block mb-1">Business Name</label>
              <Input
                value={editMerchantForm.business_name || ""}
                onChange={(e) => setEditMerchantForm({...editMerchantForm, business_name: e.target.value})}
              />
            </div>
            <div>
              <label className="text-sm text-slate-500 block mb-1">Email</label>
              <Input
                value={editMerchantForm.email || ""}
                onChange={(e) => setEditMerchantForm({...editMerchantForm, email: e.target.value})}
              />
            </div>
            <div>
              <label className="text-sm text-slate-500 block mb-1">Verification Status</label>
              <Select 
                value={editMerchantForm.verification_status || "pending"} 
                onValueChange={(v) => setEditMerchantForm({...editMerchantForm, verification_status: v})}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="pending">Pending</SelectItem>
                  <SelectItem value="verified">Verified</SelectItem>
                  <SelectItem value="rejected">Rejected</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowEditMerchant(false)}>Cancel</Button>
            <Button onClick={handleUpdateMerchant} className="bg-indigo-600 hover:bg-indigo-700">Save Changes</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Edit User Modal */}
      <Dialog open={showEditUserModal} onOpenChange={setShowEditUserModal}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Edit User</DialogTitle>
            <DialogDescription>Update user details and permissions</DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div>
              <Label className="text-sm text-slate-500 block mb-1">Name</Label>
              <Input
                value={editUserForm.name || ""}
                onChange={(e) => setEditUserForm({...editUserForm, name: e.target.value})}
                data-testid="edit-user-name"
              />
            </div>
            <div>
              <Label className="text-sm text-slate-500 block mb-1">Email</Label>
              <Input
                value={editUserForm.email || ""}
                onChange={(e) => setEditUserForm({...editUserForm, email: e.target.value})}
                data-testid="edit-user-email"
              />
            </div>
            <div>
              <Label className="text-sm text-slate-500 block mb-1">Role</Label>
              <Select 
                value={editUserForm.role || "customer"} 
                onValueChange={(v) => setEditUserForm({...editUserForm, role: v})}
              >
                <SelectTrigger data-testid="edit-user-role">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="customer">Customer</SelectItem>
                  <SelectItem value="merchant">Merchant</SelectItem>
                  <SelectItem value="admin">Admin</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="flex items-center justify-between p-3 rounded-lg bg-slate-50">
              <div>
                <Label className="text-slate-700">Account Active</Label>
                <p className="text-xs text-slate-500">User can access the platform</p>
              </div>
              <Switch
                checked={editUserForm.is_approved !== false}
                onCheckedChange={(v) => setEditUserForm({...editUserForm, is_approved: v})}
                data-testid="edit-user-active"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowEditUserModal(false)}>Cancel</Button>
            <Button onClick={handleUpdateUser} className="bg-indigo-600 hover:bg-indigo-700" data-testid="save-user-btn">
              Save Changes
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Add AI Credits Modal */}
      <Dialog open={showAddCreditsModal} onOpenChange={setShowAddCreditsModal}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Sparkles className="h-5 w-5 text-purple-500" />
              Add AI Credits
            </DialogTitle>
            <DialogDescription>Add AI generation credits to a merchant account</DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div>
              <Label className="text-sm text-slate-500 block mb-1">Select Merchant</Label>
              <Select 
                value={selectedMerchantForCredits} 
                onValueChange={setSelectedMerchantForCredits}
              >
                <SelectTrigger data-testid="select-merchant-credits">
                  <SelectValue placeholder="Select a merchant..." />
                </SelectTrigger>
                <SelectContent>
                  {merchants.filter(m => m.is_approved && !m.is_deleted).map((m) => (
                    <SelectItem key={m.user_id} value={m.user_id}>
                      {m.business_name || m.name} ({m.email})
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-sm text-slate-500 block mb-1">Credit Amount</Label>
              <Input
                type="number"
                value={creditAmount}
                onChange={(e) => setCreditAmount(parseInt(e.target.value) || 0)}
                min={1}
                data-testid="credit-amount"
              />
              <p className="text-xs text-slate-500 mt-1">5 credits = 1 image, 50 credits = 1 video</p>
            </div>
            <div>
              <Label className="text-sm text-slate-500 block mb-1">Reason</Label>
              <Input
                value={creditReason}
                onChange={(e) => setCreditReason(e.target.value)}
                placeholder="e.g., Welcome bonus, Compensation"
                data-testid="credit-reason"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowAddCreditsModal(false)}>Cancel</Button>
            <Button 
              onClick={handleAddAICredits} 
              disabled={!selectedMerchantForCredits || creditAmount <= 0}
              className="bg-purple-600 hover:bg-purple-700"
              data-testid="add-credits-btn"
            >
              <Sparkles className="h-4 w-4 mr-2" />
              Add {creditAmount} Credits
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Plan & Feature Access Modal */}
      <Dialog open={showPlanModal} onOpenChange={setShowPlanModal}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Plan & Feature Access</DialogTitle>
            <DialogDescription>
              Manage {selectedMerchant?.business_name || selectedMerchant?.name}'s feature access (5% commission model)
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="p-3 rounded-lg bg-emerald-50 border border-emerald-200">
              <p className="text-sm font-medium text-emerald-800">5% Commission Plan — All features included</p>
              <p className="text-xs text-emerald-600 mt-1">No monthly fees. Commission deducted per transaction.</p>
            </div>
            
            <div className="space-y-3 pt-2">
              <h4 className="font-medium text-slate-700">Feature Access</h4>
              
              <div className="flex items-center justify-between p-3 rounded-lg bg-slate-50">
                <div>
                  <Label className="text-slate-700">POS System</Label>
                  <p className="text-xs text-slate-500">Point of Sale terminal access</p>
                </div>
                <Switch
                  checked={planForm.pos_enabled}
                  onCheckedChange={(v) => setPlanForm({...planForm, pos_enabled: v})}
                  data-testid="pos-toggle"
                />
              </div>
              
              <div className="flex items-center justify-between p-3 rounded-lg bg-slate-50">
                <div>
                  <Label className="text-slate-700">CRM</Label>
                  <p className="text-xs text-slate-500">Customer relationship management</p>
                </div>
                <Switch
                  checked={planForm.crm_enabled}
                  onCheckedChange={(v) => setPlanForm({...planForm, crm_enabled: v})}
                  data-testid="crm-toggle"
                />
              </div>
              
              <div className="flex items-center justify-between p-3 rounded-lg bg-slate-50">
                <div>
                  <Label className="text-slate-700">AI Social Suite</Label>
                  <p className="text-xs text-slate-500">AI content generation tools</p>
                </div>
                <Switch
                  checked={planForm.ai_enabled}
                  onCheckedChange={(v) => setPlanForm({...planForm, ai_enabled: v})}
                  data-testid="ai-toggle"
                />
              </div>
              
              <div className="flex items-center justify-between p-3 rounded-lg bg-slate-50">
                <div>
                  <Label className="text-slate-700">Services & Bookings</Label>
                  <p className="text-xs text-slate-500">Appointment booking system</p>
                </div>
                <Switch
                  checked={planForm.services_enabled}
                  onCheckedChange={(v) => setPlanForm({...planForm, services_enabled: v})}
                  data-testid="services-toggle"
                />
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowPlanModal(false)}>Cancel</Button>
            <Button onClick={handleSavePlanChanges} className="bg-indigo-600 hover:bg-indigo-700" data-testid="save-plan-btn">
              Save Changes
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Change Subscription Plan Modal */}
      <Dialog open={showChangeSubModal} onOpenChange={setShowChangeSubModal}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="font-heading">Change Merchant Plan</DialogTitle>
            <DialogDescription>
              Update the plan for {selectedSubMerchant?.merchant_name || selectedSubMerchant?.merchant_email}
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="p-3 rounded-lg bg-emerald-50 border border-emerald-200">
              <p className="font-medium text-emerald-800">5% Commission Plan</p>
              <p className="text-xs text-emerald-600 mt-1">All merchants are on the commission model. No monthly billing.</p>
            </div>
            <p className="text-sm text-slate-500">
              All features are included. Use the Feature Access modal to toggle specific features on/off for individual merchants.
            </p>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowChangeSubModal(false)}>
              Close
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* V2 Manage Add-ons Modal */}
      <Dialog open={showManageAddonsModal} onOpenChange={setShowManageAddonsModal}>
        <DialogContent className="max-w-md" data-testid="manage-addons-modal">
          <DialogHeader>
            <DialogTitle>Manage Feature Access</DialogTitle>
            <DialogDescription>
              Update feature access for {selectedSubMerchant?.merchant_name || "merchant"}
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            {/* Base Plan - Always included */}
            <div className="p-4 rounded-lg border-2 border-emerald-500 bg-emerald-50">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <Check className="h-5 w-5 text-emerald-600" />
                  <div>
                    <span className="font-medium text-slate-900">5% Commission Plan</span>
                    <span className="text-xs text-slate-500 block">All features included</span>
                  </div>
                </div>
                <span className="font-semibold text-emerald-600">Included</span>
              </div>
            </div>
            
            {/* Add-ons */}
            <div className="space-y-3">
              <p className="text-sm font-medium text-slate-700">Feature Modules:</p>
              {[
                { id: "crm", name: "CRM Module", price: null },
                { id: "pos", name: "POS Module", price: null },
                { id: "services", name: "Services & Booking", price: null }
              ].map((addon) => (
                <label
                  key={addon.id}
                  className={`flex items-center gap-3 p-4 rounded-lg border-2 cursor-pointer transition-all ${
                    selectedAddonsForAdmin.includes(addon.id)
                      ? "border-indigo-500 bg-indigo-50"
                      : "border-slate-200 hover:border-indigo-300"
                  }`}
                  data-testid={`admin-addon-${addon.id}`}
                >
                  <input
                    type="checkbox"
                    checked={selectedAddonsForAdmin.includes(addon.id)}
                    onChange={() => toggleAddonForAdmin(addon.id)}
                    className="w-4 h-4 text-indigo-600 rounded"
                  />
                  <div className="flex-1">
                    <span className="font-medium text-slate-900">{addon.name}</span>
                  </div>
                  <span className="font-semibold text-emerald-600">Included</span>
                </label>
              ))}
            </div>
            
            {/* Total */}
            <div className="p-4 rounded-lg bg-slate-100">
              <div className="flex items-center justify-between">
                <span className="text-slate-600">Plan:</span>
                <span className="text-xl font-bold text-slate-900">
                  5% Commission
                </span>
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowManageAddonsModal(false)}>
              Cancel
            </Button>
            <Button 
              onClick={handleUpdateMerchantAddons}
              className="bg-indigo-600 hover:bg-indigo-700"
              disabled={updatingAddons}
              data-testid="save-addons-btn"
            >
              {updatingAddons ? "Updating..." : "Save Changes"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Fix/Approve Subscription Modal */}
      <Dialog open={showFixSubscriptionModal} onOpenChange={setShowFixSubscriptionModal}>
        <DialogContent className="max-w-md" data-testid="fix-subscription-modal">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <CheckCircle className="h-5 w-5 text-emerald-500" />
              Fix/Approve Subscription
            </DialogTitle>
            <DialogDescription>
              Manually approve {merchantToFix?.name}'s subscription. Use this if they paid via Stripe but the system didn't update correctly.
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            {/* Merchant Info */}
            <div className="p-4 rounded-lg bg-slate-50">
              <p className="font-medium text-slate-900">{merchantToFix?.name}</p>
              <p className="text-sm text-slate-500">{merchantToFix?.email}</p>
              {merchantToFix?.business_name && (
                <p className="text-sm text-indigo-600">{merchantToFix?.business_name}</p>
              )}
            </div>
            
            {/* Base Plan - Always included */}
            <div className="p-4 rounded-lg border-2 border-emerald-500 bg-emerald-50">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <Check className="h-5 w-5 text-emerald-600" />
                  <div>
                    <span className="font-medium text-slate-900">5% Commission Plan</span>
                    <span className="text-xs text-slate-500 block">All features included</span>
                  </div>
                </div>
                <span className="font-semibold text-emerald-600">Included</span>
              </div>
            </div>
            
            {/* Optional Add-ons */}
            <div className="space-y-3">
              <p className="text-sm font-medium text-slate-700">Include Feature Modules:</p>
              {[
                { id: "crm", name: "CRM Module", price: null },
                { id: "pos", name: "POS Module", price: null },
                { id: "services", name: "Services & Booking", price: null }
              ].map((addon) => (
                <label
                  key={addon.id}
                  className={`flex items-center gap-3 p-3 rounded-lg border-2 cursor-pointer transition-all ${
                    fixAddons.includes(addon.id)
                      ? "border-indigo-500 bg-indigo-50"
                      : "border-slate-200 hover:border-indigo-300"
                  }`}
                  data-testid={`fix-addon-${addon.id}`}
                >
                  <input
                    type="checkbox"
                    checked={fixAddons.includes(addon.id)}
                    onChange={() => toggleFixAddon(addon.id)}
                    className="w-4 h-4 text-indigo-600 rounded"
                  />
                  <div className="flex-1">
                    <span className="font-medium text-slate-900">{addon.name}</span>
                  </div>
                  <span className="font-semibold text-emerald-600">Included</span>
                </label>
              ))}
            </div>
            
            {/* Total */}
            <div className="p-4 rounded-lg bg-gradient-to-r from-emerald-600 to-teal-600">
              <div className="flex items-center justify-between text-white">
                <span>Plan to Activate:</span>
                <span className="text-xl font-bold">
                  5% Commission
                </span>
              </div>
            </div>
            
            {/* Warning */}
            <div className="p-3 rounded-lg bg-amber-50 border border-amber-200">
              <p className="text-sm text-amber-800">
                <AlertCircle className="h-4 w-4 inline mr-1" />
                This will immediately unlock the merchant's dashboard and give them access to selected features.
              </p>
            </div>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowFixSubscriptionModal(false)}>
              Cancel
            </Button>
            <Button 
              onClick={handleFixSubscription}
              className="bg-emerald-600 hover:bg-emerald-700"
              disabled={fixingSubscription}
              data-testid="confirm-fix-subscription-btn"
            >
              {fixingSubscription ? (
                <>
                  <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                  Fixing...
                </>
              ) : (
                <>
                  <CheckCircle className="h-4 w-4 mr-2" />
                  Approve Subscription
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Sync Connect Account Modal */}
      <Dialog open={showSyncConnectModal} onOpenChange={setShowSyncConnectModal}>
        <DialogContent className="max-w-md" data-testid="sync-connect-modal">
          <DialogHeader>
            <DialogTitle className="font-heading flex items-center gap-2">
              <CreditCard className="h-5 w-5 text-blue-500" />
              Sync Stripe Connect Account
            </DialogTitle>
            <DialogDescription>
              Link an existing Stripe Connect account to this merchant. Use this when the merchant completed 
              Stripe onboarding but it's not showing in the system.
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            {merchantToSyncConnect && (
              <div className="p-4 bg-gray-50 rounded-lg">
                <p className="font-medium text-slate-900">{merchantToSyncConnect.name}</p>
                <p className="text-sm text-slate-500">{merchantToSyncConnect.email}</p>
                <p className="text-xs text-slate-400 mt-1">ID: {merchantToSyncConnect.user_id}</p>
              </div>
            )}
            
            <div className="space-y-2">
              <label className="text-sm font-medium text-slate-700">Stripe Account ID <span className="text-red-500">*</span></label>
              <input
                type="text"
                placeholder="acct_1T4eu70Y1jj5Y5q0"
                value={syncConnectAccountId}
                onChange={(e) => setSyncConnectAccountId(e.target.value)}
                className={`w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                  syncConnectAccountId && !syncConnectAccountId.startsWith("acct_") 
                    ? "border-red-300 bg-red-50" 
                    : "border-gray-200"
                }`}
                data-testid="connect-account-id-input"
              />
              {syncConnectAccountId && !syncConnectAccountId.startsWith("acct_") && (
                <p className="text-xs text-red-500">
                  Must start with "acct_" - this is NOT an email address
                </p>
              )}
              <p className="text-xs text-gray-500">
                <strong>Where to find:</strong> Stripe Dashboard → Connect → Accounts → Click on account → Copy Account ID
              </p>
            </div>
            
            <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
              <p className="text-xs text-blue-700 font-medium mb-1">Example Stripe Account ID:</p>
              <code className="text-xs bg-blue-100 px-2 py-1 rounded">acct_1T4eu70Y1jj5Y5q0</code>
            </div>
            
            <div className="p-3 bg-amber-50 rounded-lg border border-amber-200">
              <p className="text-xs text-amber-700">
                <AlertCircle className="h-3 w-3 inline mr-1" />
                This will force-link the Stripe account even if the emails don't match.
              </p>
            </div>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowSyncConnectModal(false)}>
              Cancel
            </Button>
            <Button 
              onClick={handleSyncConnect}
              className="bg-blue-600 hover:bg-blue-700"
              disabled={syncingConnect || !syncConnectAccountId.trim() || !syncConnectAccountId.startsWith("acct_")}
              data-testid="confirm-sync-connect-btn"
            >
              {syncingConnect ? (
                <>
                  <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                  Syncing...
                </>
              ) : (
                <>
                  <CheckCircle className="h-4 w-4 mr-2" />
                  Sync Account
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AdminDashboard;
